

import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import SideNav from "./SideNav";
import TopBar from "./TopBar";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import Swal from 'sweetalert2';
import UserContext from './UserContext';
// import moment from 'moment';
import {Link, useParams, useNavigate} from "react-router-dom";
import { Modal, Button, Form } from 'react-bootstrap'; 
import QRCode from 'qrcode';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat"; 
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import moment from 'moment-timezone';


dayjs.extend(customParseFormat);


function ViewBooking() {

    const { customer_id } = useParams();

    const API_BASE_URL = process.env.REACT_APP_BASE_URL;
    const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;

    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [title, setTitle] = useState('');
    const [startDatetime, setStartDatetime] = useState('');
    const [endDatetime, setEndDatetime] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [loading, setLoading] = useState(false);
    const [timeSlotLoading, setTimeSlotLoading] = useState(false);
    const [error_list, setErrorList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [availableTimeSlots, setAvailableTimeSlot] = useState([]);
    const [kids_count, setKids_count] = useState(0);
    const [adults_count, setAdults_count] = useState(0);
    const [deposit_amount, setDeposit_amount] = useState(0);
    const [min_game, setMin_game] = useState(0);
    const [deposit_details, setDeposit_details] = useState('');
    const [grand_total, setGrand_total] = useState(0);
    const [amount_paid, setAmount_paid] = useState(0);
    const [extraPlayerPrice, setExtraPlayerPrice] = useState(0);
    const [extraGamePrice, setExtraGamePrice] = useState(0);
    const [minPlayers, setMinPlayers] = useState(0);
    const [maxPlayers, setMaxPlayers] = useState(0);
    const [hst, setHst] = useState(0);
    const [basic_price, setBasic_price] = useState(0);
    const [game_title, setGame_title] = useState('');
    const [game_description, setGame_description] = useState('');
    const [available_space, setAvailable_space] = useState('');
    const [bookedTimes, setBookedTimes] = useState([]);
    const [game_location, setGame_location] = useState('stouffville');
    const [game_type, setGame_type] = useState('');
    const [groupedBookedTimes, setGroupedBookedTimes] = useState({});
    const [bookingErrorList, setBookingErrorList] = useState([]);
    const [totalPlayersErrorList, setTotalPlayersErrorList] = useState([]);
    const [foodErrorList, setFoodErrorList] = useState([]);
    const [drinkErrorList, setDrinkErrorList] = useState([]);
    const [gameCountErrorList, setGameCountErrorList] = useState([]);
    const [eventGameCountErrorList, setEventGameCountErrorList] = useState([]);
    const [booking_date, setBooking_date] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [booking_time, setBooking_time] = useState('');
    const [cart_details, setCart_details] = useState('');
    const [timeSlotById, setTimeSlotById] = useState([]);
    const [gameTypeById, setGameTypeById] = useState([]);
    const [bookingAvailableTimeSlots, setBookingAvailableTimeSlots] = useState([]);
    const [disabledTimeSlots, setDisabledTimeSlots] = useState([]);
    const userContext = useContext(UserContext);
    const [team, setTeam] = useState([]);

    const [games, setGames] = useState([]);
    const [game_types, setGame_types] = useState([]);
    const [game_packages, setGame_packages] = useState([]);
    const [corporate_events, setCorporate_events] = useState([]);
    const [game_types_array, setGame_types_array] = useState([]);
    const [selectedGame, setSelectedGame] = useState('');
    const [selectedGameType, setSelectedGameType] = useState('');
    const [selectedGameLocation, setSelectedGameLocation] = useState('');
    const [alertShown, setAlertShown] = useState(false);

    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [note, setNote] = useState("");
    const [locations, setLocations] = useState([]);
    const [game_available, setGame_available] = useState([]);
    const [timeSlotDetails, setTimeSlotDetails] = useState([]);
    const [availableSpaces, setAvailableSpaces] = useState({});
    const [error, setError] = useState('');
    const [bookingDetails, setBookingDetails] = useState({});
    const [view, setView] = useState('form');
    const [selectedPackageType, setSelectedPackageType] = useState("");
    const [selectedBirthdayPackage, setSelectedBirthdayPackage] = useState('');
    const [selectedCorporatePackage, setSelectedCorporatePackage] = useState('');
    const [birthdayKid, setBirthdayKid] = useState("");
    const [selectedFoods, setSelectedFoods] = useState({});
    const [selectedDrinks, setSelectedDrinks] = useState({});
    const [selectedEventFoods, setSelectedEventFoods] = useState('');
    const [selectedEventDrinks, setSelectedEventDrinks] = useState('');
    const [birthdayPrice, setBirthdayPrice] = useState([]);
    const [corporatePrice, setCorporatePrice] = useState([]);
    const [game_count, setGame_count] = useState([]);
    const [eventGame_count, setEventGame_count] = useState([]);
    const [foodOptions, setFoodOptions] = useState([]);
    const [drinkOptions, setDrinkOptions] = useState([]);
    const [eventFoodOptions, setEventFoodOptions] = useState([]);
    const [eventDrinkOptions, setEventDrinkOptions] = useState([]);
    const [birthday_packages, setBirthday_packages] = useState([]);
    const [corporate_packages, setCorporate_packages] = useState([]);
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [autoDiscountApplied, setAutoDiscountApplied] = useState(false);

   
    const [emailData, setEmailData] = useState({
        to: '',
        subject: '',
        message: ''
    });

    const [email_template, setEmail_template] = useState([]);
    const [promo_code, setPromo_code] = useState([]);
    const [template, setTemplate] = useState("");
    const [template_details, setTemplate_details] = useState([]);
    const [images, setImages] = useState([]);
    const [previews, setPreviews] = useState([]);
    const [customer, setCustomer] = useState([]);
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [payment_method, setPayment_method] = useState('');
    const [fullyBookedDates, setFullyBookedDates] = useState({});
    const [initialSelectionDone, setInitialSelectionDone] = useState(false);
    const [corporateInitialSelectionDone, setCorporateInitialSelectionDone] = useState(false);
    const [eventInitialSelectionDone, setEventInitialSelectionDone] = useState(false);
    const [initialSelectionSlots, setInitialSelectionSlots] = useState('');
    const [corporateInitialSelectionSlots, setCorporateInitialSelectionSlots] = useState('');
    const [holiday, setHoliday] = useState([]);

    const [depositInfo, setDepositInfo] = useState('');
    const [parsedHolidays, setParsedHolidays] = useState([]);

   

    const handlePaymentMethodChange = (e) => {
        setPayment_method(e.target.value);
      };
    // const locationIds = userContext.userDetails.location_id
    // ? userContext.userDetails.location_id.split(',').map(id => parseInt(id.trim(), 10))
    // : [];
    
    // // Filter locations to include only those with IDs in locationIds
    // const filteredLocations = locations.filter(location => locationIds.includes(location.id));

// const today = new Date().toISOString().split('T')[0]; // Current date in YYYY-MM-DD format
     const today = (() => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  })();

const [promoCode, setPromoCode] = useState("");
const [discount, setDiscount] = useState(0);
const [showDiscountModal, setShowDiscountModal] = useState(false);
const [showPromoModal, setShowPromoModal] = useState(false);
const [discountType, setDiscountType] = useState('');
const [discountValue, setDiscountValue] = useState('');
const [discountAmount, setDiscountAmount] = useState(0);
const [promoAmount, setPromoAmount] = useState(0);
const [discountDetails, setDiscountDetails] = useState([]);
const [promoDetails, setPromoDetails] = useState([]);
const [discountDescription, setDiscountDescription] = useState("");
const [promoCodeList, setPromoCodeList] = useState([]);
const [totalBeforeHst, setTotalBeforeHst] = useState(0);

const filteredEvents = events;

    const showToast = (message) => {
        Swal.fire({
            icon: 'success',
            title: message,
            color: "white",
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3500,
            customClass: {
                popup: 'sweetalert-popup',
                title: 'sweetalert-title',
                icon: 'sweetalert-icon',
            },
            background: '#333',
            showCloseButton: true,
            padding: '4px',
        });
    };

    function assignColorsToLocations(filteredLocations) {
        const predefinedColors = ["#1c9980", "#006400", "#3357FF", "#4B0082", "#FF1493", "#915006"];  // Your predefined colors
        const locationColors = {};
    
        filteredLocations.forEach((location, index) => {
            locationColors[location.location_name.trim()] = predefinedColors[index % predefinedColors.length];
        });
    
        return locationColors;
    }

    
    const locationColors = assignColorsToLocations(filteredLocations);

    useEffect(() => {
        if (userContext.username) {
            getEmailTemplateList();
            getPromoCodeList();
           // fetchEventTimeSlots();
            getLocationByUser();
        }
    }, [userContext.username]); 

    useEffect(() => {
        // Check if email_template is loaded and has the required default template
        const defaultTemplate = email_template.find(item => item.template_name === 'Booking Confirmation');
        if (defaultTemplate) {
            setTemplate('Booking Confirmation');
            setTemplate_details(defaultTemplate);
    
            setEmailData({
                ...emailData,
                subject: defaultTemplate.subject,
                message: defaultTemplate.message
            });
        } else {
            // Reset if default template is not found
            setTemplate("");
            setTemplate_details({});
            setEmailData({ subject: "", message: "", to: "" });
        }
    }, [email_template]);
    
    async function getLocationByUser() {
        setIsLoading(true);
        try {
            const res = await axios.get(`${API_URL}/view-team-member-by-username/${userContext.username}`);
            if (res.data.status === 200) {
                const filtered = res.data.locations;
                setFilteredLocations(filtered);
    
                if (filtered.length > 0) {
                    const defaultLocation = filtered[0].id;
                    setSelectedGameLocation(defaultLocation);
                      fetchGameAvailable(defaultLocation);
                }
            } else if (res.data.status === 404) {
                // Handle 404 status if needed
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error fetching locations:", error);
        } 
    
    }

    async function getCustomer(){
        await axios.get(`${API_URL}/view-customer-by-id/${customer_id}`, ).then(res=>{
            if(res.data.status === 200){
                const fetchedCustomer = res.data.customer;
                setCustomer(res.data.customer); 
                setFirstname(fetchedCustomer.firstname || '');
                setLastname(fetchedCustomer.lastname || '');
                setPhone(fetchedCustomer.phone || '');
                setEmail(fetchedCustomer.email || '');   
            
            }     
            else if(res.data.status === 404){
                setCustomer([]);
               // setMessage(res.data.message);     
                }             
         }); 
      
 
    }

    useEffect(() => {
       
        if (customer_id) {
            getCustomer();
        }
    }, [customer_id]);

    useEffect(() => {
  
        if (selectedGameType ) {
            //setIsLoading(true);
            fetchGameTypesArray();
            //setIsLoading(false);
        }
    }, [selectedGameType]);



    useEffect(() => {
        if (selectedGameLocation && selectedGame) {
            setIsLoading(true);
            fetchEvents();
            const selectedLocationData = filteredLocations.find(loc => loc.id === Number(selectedGameLocation));
                if (selectedLocationData) {
                    setHoliday(selectedLocationData.holiday_details);
                    
                } else {
                    setHoliday([]); // No holiday data found for selected location
                 }

            //setIsLoading(false);
        }
    }, [selectedGameLocation, selectedGame]);

  
 



    const getHolidayEvents = () => {
        let holidayDetails = [];

    
        if (typeof holiday === 'string') {
            try {
                holidayDetails = JSON.parse(holiday); // Parse if it's a JSON string
            } catch (e) {
                console.error('Invalid JSON format:', e);
                return false; // Return false if parsing fails
            }
        } else if (Array.isArray(holiday)) {
            holidayDetails = holiday; // If it's already an array
        }
        if (!holidayDetails) return [];
    
        return holidayDetails.flatMap((holidayItem) => {
           const events = [];
            const start = new Date(holidayItem.holiday_from);
            const end = holidayItem.holiday_to ? new Date(holidayItem.holiday_to) : new Date(holidayItem.holiday_from);
           // end.setDate(end.getDate() + 1); // To make sure holiday_to is inclusive

            // for (
            //     let date = new Date(start);
            //     date <= end;
            //     date.setDate(date.getDate() + 1)
            // ) {
            //     events.push({
            //         title: holidayItem.name || 'Holiday',
            //         start: new Date(date),
                    
            //         //allDay: true,
            //          allDay: false,
            //         description: holidayItem.description,
            //         // display: 'background',
            //         color: '#f44336',
            //         backgroundColor: '#9c27b0',  // Set the event background color
            //         borderColor: '#9c27b0',  
            //         textColor: '#FFFFFF', 
            //         disabled: true,  
            //         extendedProps: {
            //             isHoliday: true, // Add this flag
            //             description: holidayItem.description,
            //         }
            //       });
            // }
            const isFullDay =
            start.getHours() === 0 &&
            start.getMinutes() === 0 &&
            end.getHours() === 23 &&
            end.getMinutes() === 59;

        if (isFullDay) {
            // Loop through each day for full-day holidays
            const current = new Date(start);
            while (current <= end) {
                events.push({
                    title: holidayItem.name || 'Holiday',
                    start: new Date(current),
                    allDay: true,
                    description: holidayItem.description,
                    color: '#f44336',
                    backgroundColor: '#9c27b0',
                    borderColor: '#9c27b0',
                    textColor: '#FFFFFF',
                    disabled: true,
                    extendedProps: {
                        isHoliday: true,
                        description: holidayItem.description,
                    },
                });
                current.setDate(current.getDate() + 1);
            }
        } else {
            // One single timed event (no loop)
            events.push({
                title: holidayItem.name || 'Holiday',
                start: start,
                end: end,
                allDay: false,
                description: holidayItem.description,
                color: '#f44336',
                backgroundColor: '#9c27b0',
                borderColor: '#9c27b0',
                textColor: '#FFFFFF',
                disabled: true,
                extendedProps: {
                    isHoliday: true,
                    description: holidayItem.description,
                },
            });
        }
return events;

        });
    };
    
    const isHoliday = (dateStr) => {
        let holidayDetails = [];
    
        if (typeof holiday === 'string') {
            try {
                holidayDetails = JSON.parse(holiday);
            } catch (e) {
                console.error('Invalid JSON format for holiday:', e);
                return false;
            }
        } else if (Array.isArray(holiday)) {
            holidayDetails = holiday;
        }
    
        // return holidayDetails.some(holiday => {
        //         const from = moment(holiday.holiday_from).format('YYYY-MM-DD');
        //     const to = holiday.holiday_to
        //         ? moment(holiday.holiday_to).format('YYYY-MM-DD')
        //         : from;
        //     return dateStr >= from && dateStr <= to;
         const dateTimeToCheck = moment(dateStr); // full datetime (not just date)
        
    //  return holidayDetails.some(holidayItem => {
    //     const from = moment(holidayItem.holiday_from);
    //     const to = holidayItem.holiday_to
    //         ? moment(holidayItem.holiday_to)
    //         : from;

    //     return dateTimeToCheck.isBetween(from, to, null, '[]'); // inclusive on both sides

            return holidayDetails.some(holidayItem => {
        const from = moment(holidayItem.holiday_from);
        const to = holidayItem.holiday_to
            ? moment(holidayItem.holiday_to)
            : from;

  const dayStart = moment(dateStr).startOf('day');  // 00:00
  const dayEnd = moment(dateStr).endOf('day').seconds(0).milliseconds(0);  // 23:59:00

    // Only disable if holiday covers entire day exactly or beyond
    return from.isSameOrBefore(dayStart) && to.isSameOrAfter(dayEnd);
    
        });
        

    };
    
  

    const handleViewBookings = (bookingId) => {
        navigate('/booking-details/'+bookingId);      
      };

      const handleIncrement = (food) => {
        setSelectedFoods((prev) => ({
          ...prev,
          [food]: (prev[food] || 0) + 1
        }));
      };
      
      const handleDecrement = (food) => {
        setSelectedFoods((prev) => ({
          ...prev,
          [food]: Math.max((prev[food] || 1) - 1, 0)
        }));
      };

  
      
      const getTotalSelectedFoods = () => {
        return Object.values(selectedFoods).reduce((total, count) => total + count, 0);
      };

      const handleDrinkIncrement = (drink) => {
        
        setSelectedDrinks((prev) => ({
          ...prev,
          [drink]: (prev[drink] || 0) + 1
        }));
      };
      
      const handleDrinkDecrement = (drink) => {
        setSelectedDrinks((prev) => ({
          ...prev,
          [drink]: Math.max((prev[drink] || 1) - 1, 0)
        }));
      };

      const getTotalSelectedDrinks = () => {
        return Object.values(selectedDrinks).reduce((total, count) => total + count, 0);
      };



      const handleEventFoodIncrement = (food) => {
        setSelectedEventFoods((prev) => ({
          ...prev,
          [food]: (prev[food] || 0) + 1
        }));
      };
      
      const handleEventFoodDecrement = (food) => {
        setSelectedEventFoods((prev) => ({
          ...prev,
          [food]: Math.max((prev[food] || 1) - 1, 0)
        }));
      };

  
      
      const getTotalSelectedEventFoods = () => {
        return Object.values(selectedEventFoods).reduce((total, count) => total + count, 0);
      };

      const handleEventDrinkIncrement = (drink) => {
        setSelectedEventDrinks((prev) => ({
          ...prev,
          [drink]: (prev[drink] || 0) + 1
        }));
      };
      
      const handleEventDrinkDecrement = (drink) => {
        setSelectedEventDrinks((prev) => ({
          ...prev,
          [drink]: Math.max((prev[drink] || 1) - 1, 0)
        }));
      };

      const getTotalSelectedEventDrinks = () => {
        return Object.values(selectedEventDrinks).reduce((total, count) => total + count, 0);
      };



    const fetchLocations = async () => {
        try {

            const response = await axios.get(`${API_URL}/view-game-location`);
            setLocations(response.data.gameLocation || []);
        } catch (error) {
            console.error("Error fetching locations:", error);
        }
      //  setIsLoading(false);
    };

    function onSelectImages(event){
        const selectedImages = Array.from(event.target.files);

            const validImages = selectedImages.filter(image => image.size <= 15 * 1024 * 1024); // 15MB 
            if (validImages.length !== selectedImages.length) {
              Swal.fire({
                text: "Image file size should be less than or equal to 15MB.",
                icon: "error"
              });
            }       
            setImages([...images, ...validImages]);       
        
           //  console.log([...images, ...validImages]);
           // const filePreviews = validImages.map((image) => URL.createObjectURL(image));
    
            const filePreviews = validImages.map(file => {
            if (file.type === 'application/pdf') {
                return { type: 'pdf', name: file.name , url: URL.createObjectURL(file)};
            } else if (file.type === 'video/mp4') {
              return { type: 'video', name: file.name, url: URL.createObjectURL(file) };
             } else {
                return { type: 'image', name: file.name ,url: URL.createObjectURL(file) };
            }
        });
    
            setPreviews([...previews, ...filePreviews]);
            

        
      }

    const fetchOptionsForBirthdayPackage = async (selectedBirthdayPackageId) => {
        try {
       
          const response = await axios.get(`${API_URL}/view-game-package-by-selectedBirthdayId/${selectedBirthdayPackageId}`);
          setBirthday_packages(response.data.gamePackages[0]);

         const foodDetails = response.data.gamePackages[0].food_details || '';
      const drinkDetails = response.data.gamePackages[0].drink_details || '';

      setFoodOptions(foodDetails.split(',').map(item => item.trim()).filter(item => item));
      setDrinkOptions(drinkDetails.split(',').map(item => item.trim()).filter(item => item));
       setGame_count(response.data.gamePackages[0].min_games)
    } catch (error) {
          console.error("Error fetching locations:", error);
        }
      };

      const fetchOptionsForCorporatePackage = async (selectedCorporatePackageId) => {
        try {
       
          const response = await axios.get(`${API_URL}/view-corporate-event-by-selectedCorporateId/${selectedCorporatePackageId}`);
          setCorporate_packages(response.data.corporateEvents[0]);

         const foodDetails = response.data.corporateEvents[0].food_details || '';
      const drinkDetails = response.data.corporateEvents[0].drink_details || '';

      setEventFoodOptions(foodDetails.split(',').map(item => item.trim()).filter(item => item));
      setEventDrinkOptions(drinkDetails.split(',').map(item => item.trim()).filter(item => item));
       setEventGame_count(response.data.corporateEvents[0].min_games)
    } catch (error) {
          console.error("Error fetching locations:", error);
        }
      };


    const getGameTypeList = async (selectedGameType) => {
        try {
            const res = await axios.get(`${API_URL}/view-time-slot-by-game-type/${selectedGameType}`);
            if (res.data.status === 200) {
                const timeSlot = res.data.gameType[0];
                setGameTypeById(timeSlot);


            } else if (res.data.status === 404) {
                setBookingAvailableTimeSlots([]);
            }
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching game type:', error);
        }
    };

   

    const handleTemplateChange  = (event) => {
        setTemplate(event.target.value);
        if(event.target.value){
            const template_details = email_template.find(item=> item.template_name === event.target.value);
            setTemplate_details(template_details);

        //     const currentPageUrl = window.location.href;

        //  // let updatedSubject = template_details.subject.replace(/\[model\]/g, vehicleListName ? vehicleListName : '')
          let updatedSubject = template_details.subject
        //   .replace(/\[model\]/g, vehicleListName && (selectedMakes.split(',').length == 1 || selectedModels.split(',').length == 1 )? vehicleListName : '')
          let updatedMessage = template_details.message
        //      // .replace(/\[model\]/g, vehicleListName  ? vehicleListName : '')
        //       .replace(/\[model\]/g, vehicleListName && (selectedMakes.split(',').length == 1 || selectedModels.split(',').length == 1 )? vehicleListName : '')
        //       .replace(/\[link\]/g, currentPageUrl + '?email=true')
        
              setSubject(updatedSubject);
              setMessage(updatedMessage);


              setEmailData({
                ...emailData,
                subject: updatedSubject,
                message: updatedMessage
            });

            
        
        }
        else
        {   setTemplate(""); 
            setTemplate_details([]);
            setSubject("");
            setMessage("");
            // setPreviews([]);
            // setImages([]);
        }
        };
    

        function getEmailTemplateList()
        {    
          axios.get(`${API_URL}/view-email-template`).then(res=>{
              if(res.data.status === 200){
                  setEmail_template(res.data.emailTemplate);       
              }     
              else if(res.data.status === 404){
                setEmail_template([]);
                 // setMessage(res.data.message);     
                  }             
           });    
        }

  
        function getPromoCodeList()
        {    
          axios.get(`${API_URL}/view-active-code`).then(res=>{
              if(res.data.status === 200){
                  setPromoCodeList(res.data.promoCodes);       
              }     
              else if(res.data.status === 404){
                setPromoCodeList([]);
                 // setMessage(res.data.message);     
                  }             
           });    
        }


    const fetchTimeSlots = async () => {
        setTimeSlotLoading(true);
        try {
  
            const response = await axios.get(`${API_URL}/fetch-time-slots`, {
                params: {
                    location_id: selectedGameLocation,
                    game_id: selectedGame,
                    game_type_id: selectedGameType,
                    selected_date: selectedDate,
                    created_by: userContext.userDetails.id,
                }
            });
            //   setTimeSlotDetails(prevState => ({
            //     ...prevState,
            //     [selectedGameType]: response.data // Assuming the response is an array with one object for the selected game type
            //   }));


            setTimeSlotDetails(response.data);
          
            const timeSlot = response.data;

            const { start_time, end_time, time_slot_interval } = timeSlot;
            const timeSlots = calculateTimeSlots(start_time, end_time, parseInt(time_slot_interval, 10));
            const formattedTimeSlots = formatTimeSlots(timeSlots);


            //   console.log('Generated Time Slots:', timeSlots);
            const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots`, {
                location_id: selectedGameLocation,
                game_id: selectedGame,
                game_type_id: selectedGameType,
                selected_date: selectedDate,
                generated_time_slots: formattedTimeSlots,
                no_of_adults: adults_count,
                no_of_children: kids_count,
            });

            const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;

            setTimeSlotDetails(timeSlot);
            setBookingAvailableTimeSlots(formattedTimeSlots);
            setDisabledTimeSlots(disabledTimeSlots);
            // console.log(formattedTimeSlots)
            setAvailableSpaces(availableSpaces);

            await new Promise(resolve => setTimeout(resolve, 300));

           //  console.log('Fetched Data:', comparisonResponse.data);

        } catch (error) {
            console.error('Error fetching data:', error);

        }
        setTimeSlotLoading(false);
    }


    const fetchTimeSlotsBirthday = async () => {
        setTimeSlotLoading(true);
     
        try {
            const response = await axios.get(`${API_URL}/fetch-time-slots-birthday`, {
                params: {
                    location_id: selectedGameLocation,
                    game_id: selectedGame,
                    game_package_id: selectedBirthdayPackage,
                    selected_date: selectedDate,
                    created_by: userContext.userDetails.id,
                }
            });
           


            setTimeSlotDetails(response.data);
            const timeSlot = response.data;

            const { start_time, end_time, time_slot_interval } = timeSlot;
            const timeSlots = calculateTimeSlots(start_time, end_time, parseInt(time_slot_interval, 10));
            const formattedTimeSlots = formatTimeSlots(timeSlots);

    
            const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots-birthday`, {
                location_id: selectedGameLocation,
                game_id: selectedGame,
                game_package_id: selectedBirthdayPackage,
                // game_type_id: selectedGameType,
                selected_date: selectedDate,
                generated_time_slots: formattedTimeSlots,
                no_of_adults: adults_count,
                no_of_children: kids_count,
            });

            const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;

             
            
            setTimeSlotDetails(timeSlot);
            setBookingAvailableTimeSlots(formattedTimeSlots);
            setDisabledTimeSlots(disabledTimeSlots);
            // console.log(availableSpaces);
            setAvailableSpaces(availableSpaces);

            await new Promise(resolve => setTimeout(resolve, 300));

            // console.log('Fetched Data:', comparisonResponse.data);

        } catch (error) {
            console.error('Error fetching data:', error);

        }
        setTimeSlotLoading(false);
    }

    const fetchTimeSlotsCorporate = async () => {
        setTimeSlotLoading(true);
        try {
            const response = await axios.get(`${API_URL}/fetch-time-slots-corporate`, {
                params: {
                    location_id: selectedGameLocation,
                    game_id: selectedGame,
                    corporate_event_id: selectedCorporatePackage,
                    selected_date: selectedDate,
                    created_by: userContext.userDetails.id,
                }
            });
           


            setTimeSlotDetails(response.data);
            const timeSlot = response.data;

            const { start_time, end_time, time_slot_interval } = timeSlot;
            const timeSlots = calculateTimeSlots(start_time, end_time, parseInt(time_slot_interval, 10));
            const formattedTimeSlots = formatTimeSlots(timeSlots);

    
            const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots-corporate`, {
                location_id: selectedGameLocation,
                game_id: selectedGame,
                corporate_event_id: selectedCorporatePackage,
                // game_type_id: selectedGameType,
                selected_date: selectedDate,
                generated_time_slots: formattedTimeSlots,
                no_of_adults: adults_count,
                no_of_children: kids_count,
            });

            const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;
            
            setTimeSlotDetails(timeSlot);
            setBookingAvailableTimeSlots(formattedTimeSlots);
            setDisabledTimeSlots(disabledTimeSlots);
            setAvailableSpaces(availableSpaces);
            //console.log(disabledTimeSlots);
            await new Promise(resolve => setTimeout(resolve, 300));

            // console.log('Fetched Data:', comparisonResponse.data);

        } catch (error) {
            console.error('Error fetching data:', error);

        }
        setTimeSlotLoading(false);
    }




    function fetchGameAvailable(locationId) {
       // setIsLoading(true); // Start loader for game fetching
        axios.get(`${API_URL}/view-available-game-by-locationId/${locationId}`)
            .then(res => {
                if (res.data.games) {
                    setGame_available(res.data.games);
                    if (res.data.games.length > 0) {
                        setSelectedGame(res.data.games[0].id);
                    } else {
                        setSelectedGame('');
                    }
                } else {
                    setGame_available([]);
                }
            })
            .catch(error => {
                console.error("Error fetching games:", error);
            })
           
    }

   



    useEffect(() => {
     
    setBooking_time([]);
    setAlertShown(false);

    const gameType =  game_types.find(game => game.type_slug === "public");

     
    if(selectedGameType && (adults_count + kids_count)  > 1){
   
  const totalPlayers = Number(kids_count) + Number(adults_count);

 

  if (totalPlayers < minPlayers || totalPlayers > maxPlayers) {
      setTotalPlayersErrorList(`The total number of players must be between ${minPlayers} and ${maxPlayers}.`);
      setBookingAvailableTimeSlots([]);
  } 
 
     else {
        fetchTimeSlots();
        setTotalPlayersErrorList('');

     }
    
}  



if(selectedBirthdayPackage && game_count >= birthday_packages.min_games &&  (adults_count + kids_count)  > 1)
{
    setBooking_time([]);
    setInitialSelectionDone(false);
    // const filteredPackage = game_packages.filter(item => item.id === Number(selectedBirthdayPackage));
    //         const max_players_in_a_slot = filteredPackage[0].max_players_in_a_slot;


    const totalPlayers = Number(kids_count) + Number(adults_count);

  
    if (selectedBirthdayPackage && (totalPlayers < birthday_packages.min_players || totalPlayers > birthday_packages.max_players_in_a_slot)) {
        setTotalPlayersErrorList(`The total number of players for a birthday package must be between ${birthday_packages.min_players} and ${birthday_packages.max_players_in_a_slot}.`);
        setBookingAvailableTimeSlots([]);
    } 
    else {
        setTotalPlayersErrorList('');
        fetchTimeSlotsBirthday();
     }



}

if(selectedCorporatePackage && eventGame_count >= corporate_packages.min_games &&  (adults_count + kids_count)  > 1)
    {
        setBooking_time([]);
        setEventInitialSelectionDone(false);
        // const filteredPackage = game_packages.filter(item => item.id === Number(selectedBirthdayPackage));
        //         const max_players_in_a_slot = filteredPackage[0].max_players_in_a_slot;
    
        const totalPlayers = Number(kids_count) + Number(adults_count);
        if (selectedCorporatePackage && totalPlayers < corporate_packages.min_players || totalPlayers > corporate_packages.max_players_in_a_slot) {
            setBookingAvailableTimeSlots([]);
            setTotalPlayersErrorList(`The total number of players for a corporate package must be between ${corporate_packages.min_players}. and ${corporate_packages.max_players_in_a_slot}.`);
          
        } 
        else {
            setTotalPlayersErrorList('');
            fetchTimeSlotsCorporate();
         }
    }



if(game_count < birthday_packages.min_games)
    {
        setBookingAvailableTimeSlots([]);
        setGameCountErrorList(`Please select min. ${birthday_packages.min_games} games.`);
  
    }
    else{
        setGameCountErrorList('');
    }

    if(eventGame_count < corporate_packages.min_games)
        {
            setBookingAvailableTimeSlots([]);
            setEventGameCountErrorList(`Please select min. ${corporate_packages.min_games} games.`);
      
        }
        else{
            setEventGameCountErrorList('');
        }

    

    }, [adults_count, kids_count, game_count, eventGame_count, selectedPackageType]);




    // Function to format time slots into ranges
    const formatTimeSlots = (timeSlots) => {
        const formattedSlots = [];

        for (let i = 0; i < timeSlots.length - 1; i++) {
            const startTime = timeSlots[i];
            const endTime = timeSlots[i + 1];

            // Convert to 12-hour format
            const startTime12h = convertTo12HourFormat(startTime);
            const endTime12h = convertTo12HourFormat(endTime);

            // Format the range
            const formattedRange = `${startTime12h} - ${endTime12h}`;
            formattedSlots.push(formattedRange);
        }

        return formattedSlots;
    };

    // Function to convert 24-hour time to 12-hour format
    const convertTo12HourFormat = (time24h) => {
        const [hours, minutes] = time24h.split(':');
        let period = 'AM';
        let hours12 = parseInt(hours, 10);

        if (hours12 === 0) {
            hours12 = 12;
        } else if (hours12 === 12) {
            period = 'PM';
        } else if (hours12 > 12) {
            hours12 -= 12;
            period = 'PM';
        }

        return `${hours12.toString().padStart(2, '0')}:${minutes} ${period}`;
    };


    const fetchGames = async () => {
        try {
            const response = await axios.get(`${API_URL}/view-game`);
            setGames(response.data.game);
        } catch (error) {
            console.error("Error fetching games:", error);
        }
    };


    const fetchGameTypesArray = async () => {
        try {
            const response = await axios.get(`${API_URL}/view-game-type`);

            setGame_types_array(response.data.gameType);
           // setIsLoading(false);
     
           
        } catch (error) {
            //setIsLoading(false);
            console.error("Error fetching games:", error);

        }
       
    };


    const fetchGameTypes = async (selectedGame, selectedGameLocation) => {

        try {
            const response = await axios.get(`${API_URL}/view-game-type-by-gameId/${selectedGame}/${selectedGameLocation}`);
            if (response.data.gameType) {
                setGame_types(response.data.gameType);
            }
            else {
                setGame_types([]);
            }



        } catch (error) {
            console.error("Error fetching games:", error);

        }
    };

    useEffect(() => {
        if (selectedPackageType === 'birthday_package') {
            fetchGamePackages(1);
        } 
        else if(selectedPackageType === 'corporate_event')
        {
            fetchCorporateEvents(2);
        }
    }, [selectedPackageType]);

   

    const fetchGamePackages = async (selectedPackageType) => {

        try {
            const response = await axios.get(`${API_URL}/view-game-package-by-package/${selectedGameLocation}/${selectedGame}/${selectedPackageType}`);
     
            if (response.data.gamePackages) {
                setGame_packages(response.data.gamePackages);
       
            }
            else {
                setGame_packages([]);
            }
        } catch (error) {
            console.error("Error fetching package:", error);

        }
    };

    const fetchCorporateEvents = async (selectedPackageType) => {

        try {
            const response = await axios.get(`${API_URL}/view-corporate-event-by-package/${selectedGameLocation}/${selectedGame}/${selectedPackageType}`);
     
            if (response.data.corporateEvents) {
                setCorporate_events(response.data.corporateEvents);
       
            }
            else {
                setCorporate_events([]);
            }
        } catch (error) {
            console.error("Error fetching coperate event:", error);

        }
    };


    const handleGameChange = (e) => {
        const selectedGameId = e.target.value;
        setSelectedGame(selectedGameId);
    };



    useEffect(() => {

        if (selectedGame && selectedGameLocation) {
            fetchGameTypes(selectedGame, selectedGameLocation);
        }

    }, [selectedGame, selectedGameType, selectedGameLocation]);

   

    const handleGameTypeChange = (e) => {
        setAdults_count(0);
        setKids_count(0);
        setTimeSlotDetails({});
        setGrand_total(0);
        setAmount_paid(0);
        setDeposit_amount(0);
        setExtraGamePrice(0);
        setExtraPlayerPrice(0);
        setBasic_price(0);
        setBirthdayPrice({});
        setBooking_time([]);
        setBookingAvailableTimeSlots([]);
        setTotalPlayersErrorList('');
        setGameCountErrorList('');
        setBooking_time([]);
        setBookingAvailableTimeSlots([]);
        setPayment_method('');
        setNote('');
        setTimeSlotDetails((prev) => ({ ...prev, price: 0 }));
        setBirthdayPrice((prev) => ({ ...prev, price: 0 }));
        setCorporatePrice((prev) => ({ ...prev, price: 0 }));
        const selectedGameTypeId = e.target.value;
        setSelectedGameType(selectedGameTypeId);
     
    };




    const handleBirthdayPackageChange = (e) => {
        const selectedBirthdayPackageId = e.target.value;
        setSelectedBirthdayPackage(selectedBirthdayPackageId);
        fetchOptionsForBirthdayPackage(selectedBirthdayPackageId);
        setFoodOptions([]);
        setDrinkOptions([]);
    };

    const handleCorporatePackageChange = (e) => {
        const selectedCorporatePackageId = e.target.value;
        setSelectedCorporatePackage(selectedCorporatePackageId);
        fetchOptionsForCorporatePackage(selectedCorporatePackageId);
        setEventFoodOptions([]);
        setEventDrinkOptions([]);
    };

    useEffect(() => {
     setSelectedFoods('');
     setSelectedDrinks('');
     setGame_count();
    }, [selectedBirthdayPackage]);

    useEffect(() => {
        setSelectedEventFoods('');
        setSelectedEventDrinks('');
        setEventGame_count();
       }, [selectedCorporatePackage]);

    const handleGameAvailableLocationChange = (e) => {
        const selectedGameLocationId = e.target.value;
        setSelectedGameLocation(selectedGameLocationId);
        fetchGameAvailable(selectedGameLocationId);
    };



    useEffect(() => {
        if (selectedPackageType || !selectedPackageType ) {
            // Reset counts to 0
            
            setAdults_count(0);
            setKids_count(0);
            setTimeSlotDetails({});
            setGrand_total(0);
            setDeposit_amount(0);
            setExtraGamePrice(0);
            setExtraPlayerPrice(0);
            setBasic_price(0);
            setAmount_paid(0);
            setBirthdayPrice({});
            setBooking_time([]);
            setTimeSlotDetails((prev) => ({ ...prev, price: 0 }));
            setBirthdayPrice((prev) => ({ ...prev, price: 0 }));
            setBookingAvailableTimeSlots([]);
            setTotalPlayersErrorList('');
            setGameCountErrorList('');
            setPayment_method('');
            setNote('');
            // Trigger recalculation
         
            // if (selectedGameType) {
            //     recalculateCosts();
            // } else if (selectedBirthdayPackage) {
            //     recalculateBirthdayCosts();
            // }
        }
    }, [selectedPackageType]);

    
   
    
    useEffect(() => {
        recalculateCosts();
    }, [kids_count, adults_count, selectedGameType, booking_time, discountDetails, promoDetails]);
    
    useEffect(() => {
        recalculateBirthdayCosts();
    }, [kids_count, adults_count, selectedBirthdayPackage, booking_time, discountDetails, promoDetails]);

    useEffect(() => {
        recalculateCorporateCosts();
    }, [kids_count, adults_count, selectedCorporatePackage, booking_time, discountDetails, promoDetails]);


    
    const recalculateCosts = () => {
        if (!isLoading && booking_time && selectedGameType) {


            const filteredGameType = game_types.filter(item => item.id === Number(selectedGameType));
            
            // const adultsFirstPrice = filteredGameType[0].adults_first_price;
            // const adultsSecondPrice = filteredGameType[0].adults_second_price;
            // const adultsThirdPrice = filteredGameType[0].adults_third_price;

            const adultsFirstPrice = timeSlotDetails.adults_first_price;
            const adultsSecondPrice = timeSlotDetails.adults_second_price;
            const adultsThirdPrice = timeSlotDetails.adults_third_price;
           const currentCourtPrice = timeSlotDetails.court_price;


            const depositMethod = filteredGameType[0].deposit_method;
            const depositAmountPerPerson = parseFloat(filteredGameType[0].deposit_amount_per_person).toFixed(2);
            const depositPercentage = parseFloat(filteredGameType[0].deposit_percentage).toFixed(2);
            const minPlayers = filteredGameType[0].min_players;
            const maxPlayers = filteredGameType[0].max_players;
          
          setMinPlayers(minPlayers);
          setMaxPlayers(maxPlayers);

            let totalPrice = 0;
            let slotDetails = {};
          const totalPlayers = Number(kids_count) + Number(adults_count);
         
            if (booking_time.length === 1) {
                totalPrice = (adultsFirstPrice * kids_count +
                adultsFirstPrice * adults_count) + currentCourtPrice;
             
                slotDetails[booking_time[0]] = {
                    time_slot: booking_time[0],
                    extra_game: 0,
                    extra_player:  0,
                    price_for_slot: adultsFirstPrice.toFixed(2),
                    court_price: currentCourtPrice.toFixed(2),
                    total_players: totalPlayers,
                    row_total: (adultsFirstPrice * totalPlayers).toFixed(2),
                    no_games: 0,
                    is_min_game: 0
                };


            } else if (booking_time.length === 2) {
                totalPrice = ((adultsFirstPrice * kids_count +
                    adultsFirstPrice * adults_count) + currentCourtPrice) +
                    ((adultsSecondPrice * kids_count +
                        adultsSecondPrice* adults_count) + currentCourtPrice) ;

                        
            slotDetails[booking_time[0]] = {
                time_slot: booking_time[0],
                extra_game: 0,
                extra_player:  0,
                price_for_slot: adultsFirstPrice.toFixed(2),
                court_price: currentCourtPrice.toFixed(2),
                total_players: totalPlayers,
                row_total: (adultsFirstPrice * totalPlayers).toFixed(2),
                no_games: 0,
                is_min_game: 0
            };

            slotDetails[booking_time[1]] = {
                time_slot: booking_time[1],
                extra_game: 0,
                extra_player:  0,
                price_for_slot: adultsSecondPrice.toFixed(2),
                total_players: totalPlayers,
                row_total: (adultsSecondPrice * totalPlayers).toFixed(2),
                no_games: 0,
                is_min_game: 0
            };
                    
            } else if (booking_time.length >= 3) {
                const additionalSlots = booking_time.length - 2;
                totalPrice = ((adultsFirstPrice * kids_count +
                    adultsFirstPrice * adults_count)  + currentCourtPrice) +
                    ((adultsSecondPrice * kids_count +
                        adultsSecondPrice * adults_count)  + currentCourtPrice )+
                   ( (additionalSlots * (adultsThirdPrice * kids_count +
                        adultsThirdPrice * adults_count))  + currentCourtPrice);


                        slotDetails[booking_time[0]] = {
                            time_slot: booking_time[0],
                            extra_game: 0,
                            extra_player:  0,
                            price_for_slot: adultsFirstPrice.toFixed(2),
                            total_players: totalPlayers,
                            row_total: (adultsFirstPrice * totalPlayers).toFixed(2),
                            no_games: 0,
                            is_min_game: 0
                        };
            
                        slotDetails[booking_time[1]] = {
                            time_slot: booking_time[1],
                            extra_game: 0,
                            extra_player:  0,
                            price_for_slot: adultsSecondPrice.toFixed(2),
                            total_players: totalPlayers,
                            row_total: (adultsSecondPrice * totalPlayers).toFixed(2),
                            no_games: 0,
                            is_min_game: 0
                        };
            
                        for (let i = 2; i < booking_time.length; i++) {
                            const priceForSlot = adultsThirdPrice;
                            const rowTotal = priceForSlot * totalPlayers;
            
                            slotDetails[booking_time[i]] = {
                                time_slot: booking_time[i],
                                extra_game: 0,
                                extra_player:  0,
                                price_for_slot: priceForSlot.toFixed(2),
                                total_players: totalPlayers,
                                row_total: rowTotal.toFixed(2),
                                no_games: 0,
                                is_min_game: 0
                            };
                        }
                    }
            
                    setCart_details(slotDetails);
      

            setTimeSlotDetails((prev) => ({ ...prev, price: totalPrice }));
 

            let discountAmount = 0;
            

  if (discountDetails.length > 0) {
    discountDetails.forEach(discount => {
      if (discount.type === "percentage") {
        discountAmount += totalPrice * (Number(discount.value) / 100);
      } else if (discount.type === "amount") {
        discountAmount += Number(discount.value);
      }
    });
   
  }

// if (!autoDiscountApplied && filteredGameType[0]?.discount === 1) {
//   try {
//     const parsedDiscountDetails = JSON.parse(filteredGameType[0].discount_details);
//     const numberOfBookings = booking_time.length;

//     let newDiscounts = []; // temp array for new discounts
//     let newDiscountAmount = 0; // accumulate total discount amount

//     parsedDiscountDetails.forEach(discount => {
//       const hoursFrom = Number(discount.discount_hours_from);
//       const hoursTo = Number(discount.discount_hours_to);

//       if (numberOfBookings >= hoursFrom && numberOfBookings <= hoursTo) {
//         const discountPercentage = Number(discount.discount_percentage); // e.g. 10
//         const discountAmountForThis = totalPrice * (discountPercentage / 100);
//         newDiscountAmount += discountAmountForThis;

//         newDiscounts.push({
//           type: 'percentage',
//           value: discountPercentage,
//           description: discount.discount_title || `Auto Discount (${discountPercentage}%)`,
//           amount: parseFloat(discountAmountForThis.toFixed(2)),
//         });
//       }
//     });

//     // Update discountDetails state once, appending new discounts
//     setDiscountDetails(prevDiscounts => [...prevDiscounts, ...newDiscounts]);

//     // Update total discount amount
//     discountAmount += newDiscountAmount;
//     setAutoDiscountApplied(true);

//   } catch (error) {
//     console.error("Error parsing game-type discount details:", error);
//   }
// }


  let promoAmount = 0;

  if (promoDetails.length > 0) {
    promoDetails.forEach(promo => {
      if (promo.type === "percentage") {
        const percentageDiscount = totalPrice * (Number(promo.value) / 100);
        promoAmount += percentageDiscount;
      } else if (promo.type === "amount") {
        promoAmount += Number(promo.value);
      }
    });
  }
  

  const totalDiscount = discountAmount + promoAmount;
  const cappedDiscount = Math.min(totalDiscount, totalPrice);


  const discountedPrice = totalPrice - cappedDiscount;
   setTotalBeforeHst(discountedPrice);
  
            const hst = (discountedPrice * 13) / 100;
             setHst(hst);

            // Calculate grand total
            const grandTotal = discountedPrice + hst;
            const formattedGrandTotal = parseFloat(grandTotal.toFixed(2));

            setGrand_total(formattedGrandTotal);


              // Calculate the deposit amount
        let depositInfo = '';
        let depositAmount = 0;
        if (depositMethod === 1) { // Amount per person
            depositAmount = depositAmountPerPerson * (Number(kids_count) + Number(adults_count))* booking_time.length ;
         
         depositInfo = `Deposit amount per person: ${depositAmountPerPerson} × Number of games: ${booking_time.length} × Total Number of Players: ${(Number(kids_count) + Number(adults_count))}`;
        } else if (depositMethod === 2) { // Percentage
            depositAmount = (totalPrice * depositPercentage) / 100;
            depositInfo = `${depositPercentage}% of Subtotal`;
        }
        setDeposit_amount(depositAmount);
        setAmount_paid(depositAmount);
        setDepositInfo(depositInfo);


        let depositDetails = '';
        if(depositMethod === 1)
        {
          depositDetails = 'Deposit amount per person : ' +depositAmountPerPerson;
          setDeposit_details(depositDetails);
        
        }
        else if (depositMethod === 2)
        {
           depositDetails = 'Deposit amount percentage : ' +depositPercentage;
           setDeposit_details(depositDetails);
    
        }

        // const cartDetails =  generateCartDetails(booking_time,priceForSlot);
        // setCart_details(cartDetails);
        // console.log(cartDetails);

        }
        

    }


    const recalculateBirthdayCosts = () => {
    
        if(!isLoading && booking_time  && selectedBirthdayPackage)
        {
       
            const filteredPackage = game_packages.filter(item => item.id === Number(selectedBirthdayPackage));
            const birthdayPrice = filteredPackage[0].price_per_game;
            const basicPrice= filteredPackage[0].basic_price;
            const depositAmt= filteredPackage[0].deposit_amount;
            const min_players =filteredPackage[0].min_players;
            const minGames = filteredPackage[0].min_games;
           
         
            let totalPrice = basicPrice;
            let slotDetails = {};
            const totalPlayers =  Number(kids_count) + Number(adults_count);

            const totalPlayersExcludingBirthdayKid = totalPlayers > 1 ? totalPlayers - 1 : 0; // Ensure the total doesn't go below 0
           
            const totalSlots = booking_time.length;
            const freeGames = 2; // Number of free games
    
            // // Calculate the number of paid slots
             const paidSlots = totalSlots > freeGames ? totalSlots - freeGames : 0;
            // const totalPriceForPaidSlots = birthdayPrice * totalPlayersExcludingBirthdayKid * paidSlots;
    
            // totalPrice += totalPriceForPaidSlots; // Add the calculated price

            const extraPlayers = Math.max(0, totalPlayers - min_players);

        
            
        if (totalSlots > 0) {
           
            const extraPlayerCostForBaseGames = extraPlayers * minGames * birthdayPrice;

            setExtraPlayerPrice(extraPlayerCostForBaseGames);
            const additionalPaidGames = Math.max(0, totalSlots - (minGames + freeGames));
            const extraGameCost = totalPlayersExcludingBirthdayKid * additionalPaidGames * birthdayPrice;
            setExtraGamePrice(extraGameCost);

            totalPrice += extraPlayerCostForBaseGames + extraGameCost;


       
            // Populate slot details
            // for (let i = 0; i < totalSlots; i++) {
              //  const timeSlot = booking_time[i];

              //  const isInitialSelection = initialSelectionSlots.includes(timeSlot); // Checks if it's within the initial selected slots
           
                let firstTime = initialSelectionSlots[0]?.split(" - ")[0]; // Start time of first slot
                let lastTime = initialSelectionSlots[minGames + freeGames - 1]?.split(" - ")[1]; // End time of last slot
                
                // Merge them into a single time slot
                let mergedTimeSlots = `${firstTime} - ${lastTime}`;

                // let mergedTimeSlots =  booking_time.filter((timeSlot) => {
                //     return initialSelectionSlots.includes(timeSlot); // Only keep slots that were NOT part of the base package
                // });
                
                
                // console.log(mergedTimeSlots);
                

                    slotDetails[mergedTimeSlots] = {
                        time_slot: mergedTimeSlots,
                        extra_player: 0, // Base slot has no extra players initially
                        extra_game: 0,   // Base slot has no extra games initially
                    // price_for_slot: i < freeGames ? 0 : birthdayPrice.toFixed(2),
                        price_for_slot: 0,
                        total_players: totalPlayers - totalPlayersExcludingBirthdayKid,
                    //   row_total: i < freeGames ? '0.00' : (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2),
                        row_total:basicPrice,
                    // no_games: freeGames ? 0 : 1,
                       no_games: minGames,
                       
                    // min_games: isInitialSelection ? 1 : 0,
                        is_min_game: 1,
                
                    };

                    if (totalPlayers > min_players) {
                        slotDetails["extra_player_price"] = {
                            time_slot: mergedTimeSlots,
                            extra_player: totalPlayers - totalPlayersExcludingBirthdayKid,
                            extra_game: 0,
                            price_for_slot: birthdayPrice.toFixed(2),
                            total_players: totalPlayers - min_players,
                            row_total: (extraPlayers * minGames * birthdayPrice).toFixed(2),
                            no_games: minGames.toString(),
                            is_min_game: 1,
                        };
                    }

                    const extraGameSlots = booking_time.filter((timeSlot) => {
                        return !initialSelectionSlots.includes(timeSlot); // Only keep slots that were NOT part of the base package
                    });
                    

                    extraGameSlots.forEach((extraGameSlot, index) => {
                        slotDetails[extraGameSlot] = {
                            time_slot: extraGameSlot,
                            //extra_player:  totalPlayers - totalPlayersExcludingBirthdayKid,
                            extra_player:  0,
                            extra_game: 1,
                            price_for_slot: birthdayPrice.toFixed(2),
                            total_players: totalPlayersExcludingBirthdayKid,
                            row_total: (totalPlayersExcludingBirthdayKid * birthdayPrice).toFixed(2),
                            //no_games:(freeGames + minGames) + index,
                            no_games:1,
                            is_min_game: 0,
                        };
                    });
                
        

          
                        setCart_details(slotDetails);
            
             }
            

            setBirthdayPrice((prev) => ({ ...prev, price: totalPrice }));


            let discountAmount = 0;
            

            if (discountDetails.length > 0) {
              discountDetails.forEach(discount => {
                if (discount.type === "percentage") {
                  discountAmount += totalPrice * (Number(discount.value) / 100);
                } else if (discount.type === "amount") {
                  discountAmount += Number(discount.value);
                }
              });
             
            }
          
            let promoAmount = 0;
          
            if (promoDetails.length > 0) {
              promoDetails.forEach(promo => {
                if (promo.type === "percentage") {
                  const percentageDiscount = totalPrice * (Number(promo.value) / 100);
                  promoAmount += percentageDiscount;
                } else if (promo.type === "amount") {
                  promoAmount += Number(promo.value);
                }
              });
            }
            
          
            const totalDiscount = discountAmount + promoAmount;
            const cappedDiscount = Math.min(totalDiscount, totalPrice);
          
          
            const discountedPrice = totalPrice - cappedDiscount;


   setTotalBeforeHst(discountedPrice);


        const hst = (discountedPrice * 13) / 100;
        setHst(hst);

        const grandTotal = discountedPrice + hst;
        const formattedGrandTotal = parseFloat(grandTotal.toFixed(2));


        setGrand_total(formattedGrandTotal);

        const calculatedDeposit = (totalPrice * 50) / 100;
        const calculatedDepositInfo = '50% of Subtotal'
       setDeposit_amount(calculatedDeposit.toFixed(2));
       setDepositInfo(calculatedDepositInfo);
      //  setDeposit_amount(depositAmt);
 

        setAmount_paid(calculatedDeposit.toFixed(2));
        setBasic_price(basicPrice);
     
            if(selectedBirthdayPackage && birthday_packages.min_games)  
        { 
            setMin_game(birthday_packages.min_games);
          
        }

        let depositDetails = '';
          depositDetails = 'Package basic price : ' +depositAmt;
          setDeposit_details(depositDetails);

        //   const cartDetails =  generateCartDetails(booking_time, priceForSlot);
        //   setCart_details(cartDetails);

        }
    }

   
    const recalculateCorporateCosts = () => {
    
        if(!isLoading && booking_time  && selectedCorporatePackage)
        {
       
            const filteredPackage = corporate_events.filter(item => item.id === Number(selectedCorporatePackage));
            const corporatePrice = filteredPackage[0].price_per_game;
            const basicPrice= filteredPackage[0].basic_price;
            const depositAmt= filteredPackage[0].deposit_amount;
            const min_players =filteredPackage[0].min_players;
            const minGames = filteredPackage[0].min_games;

          

            let totalPrice = basicPrice;
            let slotDetails = {};
            const totalPlayers =  Number(kids_count) + Number(adults_count);

            const totalPlayersExcludingBirthdayKid = totalPlayers > 1 ? totalPlayers - 1 : 0; // Ensure the total doesn't go below 0
           
            const totalSlots = booking_time.length;
            const freeGames = 2; // Number of free games
    
           

            const extraPlayers = Math.max(0, totalPlayers - min_players);
            if (totalSlots > 0) {
                // Extra players beyond the package limit
           
                const extraPlayerCostForBaseGames = extraPlayers * minGames * corporatePrice; // 3 extra players × 3 games × $10
                setExtraPlayerPrice(extraPlayerCostForBaseGames);
                // Extra game cost (beyond the 3 package games + 2 free games)
                const additionalPaidGames = Math.max(0, totalSlots - (minGames + freeGames)); 
                const extraGameCost = totalPlayersExcludingBirthdayKid * additionalPaidGames * corporatePrice;
                setExtraGamePrice(extraGameCost);
                // Add extra player & extra game costs only after slot selection
                totalPrice += extraPlayerCostForBaseGames + extraGameCost;
            

                let firstTime = corporateInitialSelectionSlots[0]?.split(" - ")[0]; // Start time of first slot
          
               
               let lastTime = corporateInitialSelectionSlots[minGames + freeGames - 1]?.split(" - ")[1]; // End time of last slot
               
               // Merge them into a single time slot
               let mergedTimeSlots = `${firstTime} - ${lastTime}`;
              
             // console.log(mergedTimeSlots);
             

                slotDetails[mergedTimeSlots] = {
                    time_slot: mergedTimeSlots,
                    extra_player: 0, // Base slot has no extra players initially
                    extra_game: 0,   // Base slot has no extra games initially
                   // price_for_slot: i < freeGames ? 0 : birthdayPrice.toFixed(2),
                    price_for_slot: 0,
                    total_players: totalPlayers - totalPlayersExcludingBirthdayKid,
                 //   row_total: i < freeGames ? '0.00' : (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2),
                   row_total:basicPrice,
                  // no_games: freeGames ? 0 : 1,
                  no_games: minGames,
                   // min_games: isInitialSelection ? 1 : 0,
                    is_min_game: 1,
               
                };

                if (totalPlayers > min_players) {
                    slotDetails["extra_player_price"] = {
                        time_slot: mergedTimeSlots,
                        extra_player: totalPlayers - totalPlayersExcludingBirthdayKid,
                        extra_game: 0,
                        price_for_slot: corporatePrice.toFixed(2),
                        total_players: totalPlayers - min_players,
                        row_total: (extraPlayers * minGames * corporatePrice).toFixed(2),
                        no_games: minGames.toString(),
                        is_min_game: 1,
                    };
                }

                const extraGameSlots = booking_time.filter((timeSlot) => {
                    return !corporateInitialSelectionSlots.includes(timeSlot); // Only keep slots that were NOT part of the base package
                });
                

                extraGameSlots.forEach((extraGameSlot, index) => {
                    slotDetails[extraGameSlot] = {
                        time_slot: extraGameSlot,
                        //extra_player:  totalPlayers - totalPlayersExcludingBirthdayKid,
                        extra_player:  0,
                        extra_game: 1,
                        price_for_slot: corporatePrice.toFixed(2),
                        total_players: totalPlayersExcludingBirthdayKid,
                        row_total: (totalPlayersExcludingBirthdayKid * corporatePrice).toFixed(2),
                        //no_games:(freeGames + minGames) + index,
                        no_games:1,
                        is_min_game: 0,
                    };
                });
        
            
            // console.log("Slot Details:", slotDetails,);

            // if (booking_time.length === 1) {

            //     //totalPrice += birthdayPrice * kids_count + birthdayPrice * adults_count;

            //     totalPrice += birthdayPrice * totalPlayersExcludingBirthdayKid;
               

            //     slotDetails[booking_time[0]] = {
            //         time_slot: booking_time[0],
            //         price_for_slot: birthdayPrice.toFixed(2),
            //         total_players: totalPlayersExcludingBirthdayKid,
            //         row_total: (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2)
            //     };


            // } else if (booking_time.length === 2) {
            //     // totalPrice += (birthdayPrice * kids_count + birthdayPrice * adults_count) +
            //     //               (birthdayPrice * kids_count + birthdayPrice * adults_count);
           
            //     totalPrice += birthdayPrice * totalPlayersExcludingBirthdayKid * 2;

            //                   slotDetails[booking_time[0]] = {
            //                     time_slot: booking_time[0],
            //                     price_for_slot: birthdayPrice.toFixed(2),
            //                     total_players: totalPlayersExcludingBirthdayKid,
            //                     row_total: (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2)
            //                 };
                
            //                 slotDetails[booking_time[1]] = {
            //                     time_slot: booking_time[1],
            //                     price_for_slot: birthdayPrice.toFixed(2),
            //                     total_players: totalPlayersExcludingBirthdayKid,
            //                     row_total: (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2)
            //                 };
           
            //                 } else if (booking_time.length >= 3) {
            //     const additionalSlots = booking_time.length - 2;
            //     // totalPrice += (birthdayPrice * kids_count + birthdayPrice * adults_count) +
            //     //               (birthdayPrice * kids_count + birthdayPrice * adults_count) +
            //     //               (additionalSlots * (birthdayPrice * kids_count + birthdayPrice * adults_count));
            
            //      totalPrice += birthdayPrice * totalPlayersExcludingBirthdayKid * (2 + additionalSlots);
            
            //                   slotDetails[booking_time[0]] = {
            //                     time_slot: booking_time[0],
            //                     price_for_slot: birthdayPrice.toFixed(2),
            //                     total_players: totalPlayersExcludingBirthdayKid,
            //                     row_total: (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2)
            //                 };
                
            //                 slotDetails[booking_time[1]] = {
            //                     time_slot: booking_time[1],
            //                     price_for_slot: birthdayPrice.toFixed(2),
            //                     total_players: totalPlayersExcludingBirthdayKid,
            //                     row_total: (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2)
            //                 };
                
            //                 for (let i = 2; i < booking_time.length; i++) {
            //                     slotDetails[booking_time[i]] = {
            //                         time_slot: booking_time[i],
            //                         price_for_slot: birthdayPrice.toFixed(2),
            //                         total_players: totalPlayersExcludingBirthdayKid,
            //                         row_total: (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2)
            //                     };
            //                 }
            //             }
                        setCart_details(slotDetails);
            
            
        }

            setCorporatePrice((prev) => ({ ...prev, price: totalPrice }));


            let discountAmount = 0;
            

            if (discountDetails.length > 0) {
              discountDetails.forEach(discount => {
                if (discount.type === "percentage") {
                  discountAmount += totalPrice * (Number(discount.value) / 100);
                } else if (discount.type === "amount") {
                  discountAmount += Number(discount.value);
                }
              });
             
            }
          
            let promoAmount = 0;
          
            if (promoDetails.length > 0) {
              promoDetails.forEach(promo => {
                if (promo.type === "percentage") {
                  const percentageDiscount = totalPrice * (Number(promo.value) / 100);
                  promoAmount += percentageDiscount;
                } else if (promo.type === "amount") {
                  promoAmount += Number(promo.value);
                }
              });
            }
            
          
            const totalDiscount = discountAmount + promoAmount;
            const cappedDiscount = Math.min(totalDiscount, totalPrice);
          
          
            const discountedPrice = totalPrice - cappedDiscount;



   setTotalBeforeHst(discountedPrice);


        const hst = (discountedPrice * 13) / 100;
        setHst(hst);

        const grandTotal = discountedPrice + hst;
        const formattedGrandTotal = parseFloat(grandTotal.toFixed(2));


        setGrand_total(formattedGrandTotal);

        const calculatedDeposit = (totalPrice * 50) / 100;
        setDeposit_amount(calculatedDeposit.toFixed(2));
      //  setDeposit_amount(depositAmt);
 

        setAmount_paid(calculatedDeposit.toFixed(2));
     
        setBasic_price(basicPrice);
     
            if(selectedCorporatePackage && corporate_packages.min_games)  
        { 
            setMin_game(corporate_packages.min_games);
          
        }

        let depositDetails = '';
          depositDetails = 'Package basic price : ' +depositAmt;
          setDeposit_details(depositDetails);

        //   const cartDetails =  generateCartDetails(booking_time, priceForSlot);
        //   setCart_details(cartDetails);

        }
    }




    function fetchEvents() {

        axios.get(`${API_URL}/view-booked-slots/${selectedGameLocation}/${selectedGame}`).then(res => {
  
            if (res.data.status === 200) {

                const fullyBookedDates = {};


                const formattedEvents = res.data.bookedSlots.map(slot => {
                    const bookingTimes = Array.isArray(slot.booked_time) ? slot.booked_time : JSON.parse(slot.booked_time);
                    // const startTime = new Date(`${slot.booked_date} ${bookingTimes[0].split(' - ')[0]}`);
                    // const endTime = new Date(`${slot.booked_date} ${bookingTimes[bookingTimes.length - 1].split(' - ')[1]}`);

                    const startTime = moment(`${slot.booked_date} ${bookingTimes[0].split(' - ')[0]}`, 'YYYY-MM-DD h:mm A');
                    const endTime = moment(`${slot.booked_date} ${bookingTimes[bookingTimes.length - 1].split(' - ')[1]}`, 'YYYY-MM-DD h:mm A');

                    const formattedBookedTime = formatBookedTime(slot.booked_time);

                    // Format times
                    const startFormatted = startTime.format('h:mm A');
                    const endFormatted = endTime.format('h:mm A');

                    // const typeOrPackageName = slot.game_type_name ? slot.game_type_name : slot.package_name;
                    
                    const locationShort = slot.location_name.substring(0, 3);
                    const typeOrPackageName = slot.game_type_name ? slot.game_type_name : slot.package_name;
                    // const typeOrPackageShort = typeOrPackageName.substring(0, 3);
                    const typeOrPackageShort = typeOrPackageName ? typeOrPackageName.substring(0, 3) : "";


                    const className = typeOrPackageName === 'Birthday' ? 'birthday-event' : '';
                    
                    const eventColor = locationColors[slot.location_name] || '#000000'; 
                   
                      const isSameDay = slot.is_same_day === 1;
                   
                    const formattedEvent = {
                        // title: `${slot.location_name} - ${typeOrPackageName} - Adults: ${slot.no_of_adults}, Kids: ${slot.no_of_children}`,
                        title: `${formattedBookedTime} - ${locationShort} - ${typeOrPackageShort} A-${slot.no_of_adults} K-${slot.no_of_children} `  +
                        (slot.staff_first_name || slot.staff_last_name
                            ? `Co- ${slot.staff_first_name}` : ''),
                        start: startTime.toISOString(),
                        end: endTime.toISOString(),
                        description: `${slot.game_name} - ${typeOrPackageName} at ${slot.location_name}`,
                        className: className + (isSameDay ? ' same-day-booking' : ''),
                        backgroundColor: isSameDay ? '#ff3333' : eventColor, // Light red for same-day bookings
                        borderColor: isSameDay ? '#ff0000' : eventColor,   
                        textColor: '#FFFFFF', 
                        extendedProps: {
                            booked_date: slot.booked_date,
                            location_name: slot.location_name,
                            game_type_name: slot.game_type_name,
                            package_name: slot.package_name,
                            game_name: slot.game_name,
                            booked_time: bookingTimes.join(', '),
                            no_of_adults: slot.no_of_adults,
                            no_of_children: slot.no_of_children,
                            firstname: slot.firstname, // Add customer first name
                            lastname: slot.lastname,  // Add customer last name
                            email: slot.email,        // Add customer email
                            phone: slot.phone,
                            start_time: startFormatted, // Start time
                            end_time: endFormatted,
                            booked_times: formattedBookedTime,
                            birthday_kid_name: slot.birthday_kid_name,
                            food_details: slot.food_details,
                            drink_details: slot.drink_details,
                            amount_paid: slot.amount_paid,
                           game_package_name: slot.game_package_name,
                           booking_id: slot.booking_id,
                           corporate_package_name :slot.corporate_package_name

                        }
                    };
                    // const dateKey = slot.booked_date;
                    // fullyBookedDates[dateKey] = fullyBookedDates[dateKey] || [];
                    // fullyBookedDates[dateKey].push(formattedBookedTime);
    
                    return formattedEvent;
                });
    
                // Check if all slots are booked for each date
                // for (const dateKey in fullyBookedDates) {
                //     const totalSlotsForDay = calculateTimeSlots('9:00 AM', '5:00 PM', 30); // Example: Generate slots from 9:00 AM to 5:00 PM with 30 min interval
                //     const bookedSlotsForDay = fullyBookedDates[dateKey];

                    // console.log(totalSlotsForDay);
    
                    // If all time slots are booked, mark the date as fully booked
                    // if (bookedSlotsForDay.length === totalSlotsForDay.length) {
                    //     fullyBookedDates[dateKey] = true; // Mark as fully booked
                    // }
                // }
    
                setEvents(formattedEvents);

               

                // setFullyBookedDates(fullyBookedDates);
                setIsLoading(false);



            }
            else if (res.data.status === 404) {
                setEvents([]);
                setIsLoading(false);
            }
  
           
        });

    }



    const handleEventClick = ({ event }) => {
        if (event.extendedProps?.isHoliday) {
            return; // Ignore clicks on holiday
        }
    
        if (event.extendedProps) {
            setBookingDetails(event.extendedProps);
          //  console.log(event.extendedProps);
            setView('details');
        } else {
           // console.log('No details found in event extendedProps');
        }
    };


    const calculateTimeSlots = (startTime, endTime, interval) => {
        const timeSlots = [];
        const [startHour, startMinute] = parseTime(startTime);
        const [endHour, endMinute] = parseTime(endTime);

        let current = new Date();
        current.setHours(startHour, startMinute, 0, 0);

        const end = new Date();
        end.setHours(endHour, endMinute, 0, 0);

        while (current <= end) {
            const timeSlot = current.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
            timeSlots.push(timeSlot);
            current.setMinutes(current.getMinutes() + interval);
        }

        return timeSlots;
    };


    const parseTime = (timeString) => {
        const [time, period] = timeString.split(' ');
        const [hours, minutes] = time.split(':').map(Number);
        const adjustedHours = period === 'PM' && hours !== 12 ? hours + 12 : hours;
        return [adjustedHours, minutes];
    };

   
    const handleBookingDateChange = (selectedDate) => {
        let errors = {};
        if (!selectedGameLocation) {
            errors.location_id = "Please select a game location.";
        }

        if (!selectedGame) {
            errors.game_id = "Please select a game.";
        }


        if (Object.keys(errors).length > 0) {
            setErrorList(errors);
            return;
        }

        setIsLoading(true);
        resetBooking();

        if (selectedGameLocation && selectedGame) {
            setBooking_date(selectedDate);
            setView('form');
        }

        if(customer_id)
        { 
            getCustomer();
         
        }

        
        setIsLoading(false);

    };

    const spaceDisabledSlots = bookingAvailableTimeSlots
    .filter((timeSlot, index) => {
        const game_type = game_types_array.find(item => item.id.toString() === selectedGameType);
        const maxPlayers = game_packages?.[0]?.max_players_in_a_slot || 0; // Use 0 or a default value if undefined
        const remainingSpace = availableSpaces[timeSlot] || 0;

        // For birthday package, check if remaining space doesn't match the max player requirement
        if (selectedPackageType === 'birthday_package' && remainingSpace !== maxPlayers) {
            return true; // This slot should be disabled
        }
        return false;
    });

    const spaceDisabledSlotsCorporate = bookingAvailableTimeSlots
    .filter((timeSlot, index) => {
        const game_type = game_types_array.find(item => item.id.toString() === selectedGameType);
        const maxPlayers = corporate_events[0]?.max_players_in_a_slot;
        const remainingSpace = availableSpaces[timeSlot] || 0;

        // For birthday package, check if remaining space doesn't match the max player requirement
        if (selectedPackageType === 'corporate_event' && remainingSpace !== maxPlayers) {
            return true; // This slot should be disabled
        }
        return false;
    });


    const handleTimeSlotChange = (event) => {
        const selectedTimeSlot = event.target.value;
        const selectedSlotIndex = bookingAvailableTimeSlots.indexOf(selectedTimeSlot);
     

        if (selectedPackageType === 'birthday_package') {
            
                const userGameCount = parseInt(game_count, 10); // Get the number of games selected by the user
                const totalSlotsToSelect = userGameCount + 2; // Add 2 free games

                const nextSlots = bookingAvailableTimeSlots.slice(selectedSlotIndex, selectedSlotIndex + totalSlotsToSelect);
                
           

                if (!initialSelectionDone) {

                    const hasConflict = nextSlots.length !== totalSlotsToSelect ||
                    nextSlots.some(slot => disabledTimeSlots.includes(slot) || spaceDisabledSlots.includes(slot));

                    // if (nextSlots.length !== totalSlotsToSelect || nextSlots.some(slot => disabledTimeSlots.includes(slot))) {
                    //     alert('Please choose a different start time as this start time won’t allow for 2.5 hours.');
                    //     return; // Exit without making changes
                    // }

                    if (hasConflict) {
                        alert('Please choose a different start time as this start time won’t allow for 2.5 hours.');
                        return; // Exit without making changes
                    }
                    // Set the consecutive slots for the first time
                    setBooking_time(nextSlots); // Clear all previous selections and set only the new consecutive slots
                    setInitialSelectionDone(true); // Mark the initial selection as done
                    setInitialSelectionSlots(nextSlots);
                } else {
                    // Allow single slot selection after the initial consecutive slots have been selected
                    setBooking_time((prevBookingTime) => {
                        let newBookingTime = [...prevBookingTime];
        
                        
                if (initialSelectionSlots.includes(selectedTimeSlot)) {
                    newBookingTime = []; // Clear all selections
                    setInitialSelectionDone(false); // Reset the initial selection state
                    setInitialSelectionSlots([]); // Clear the initial selection slots
                } else if (prevBookingTime.includes(selectedTimeSlot)) {
                    // If the time slot is already selected, unselect it (independent slot)
                    newBookingTime = newBookingTime.filter(slot => slot !== selectedTimeSlot);
                // } else {
                //     // If the time slot is not selected, select it (independent slot)
                //     newBookingTime.push(selectedTimeSlot);
                // }

            } else {
                const firstSelectedSlot = newBookingTime[0];
                const lastSelectedSlot = newBookingTime[newBookingTime.length - 1];
                const firstSelectedIndex = bookingAvailableTimeSlots.indexOf(firstSelectedSlot);
                const lastSelectedIndex = bookingAvailableTimeSlots.indexOf(lastSelectedSlot);

                if (selectedSlotIndex === firstSelectedIndex - 1 || selectedSlotIndex === lastSelectedIndex + 1) {
                    newBookingTime.push(selectedTimeSlot);
                    newBookingTime.sort((a, b) => bookingAvailableTimeSlots.indexOf(a) - bookingAvailableTimeSlots.indexOf(b));
                } else {
                    alert("Please select consecutive time slots.");
                }
            }
                        return newBookingTime;
                    });
                }
            }

else  if (selectedPackageType === 'corporate_event') {
            
    const userGameCount = parseInt(eventGame_count, 10); // Get the number of games selected by the user
    const totalSlotsToSelect = userGameCount + 2; // Add 2 free games

    const nextSlots = bookingAvailableTimeSlots.slice(selectedSlotIndex, selectedSlotIndex + totalSlotsToSelect);
    


    if (!corporateInitialSelectionDone) {

        const hasConflict = nextSlots.length !== totalSlotsToSelect ||
        nextSlots.some(slot => disabledTimeSlots.includes(slot) || spaceDisabledSlotsCorporate.includes(slot));

        if (hasConflict) {
            alert('Please choose a different start time as this start time won’t allow for 2.5 hours.');
            return; // Exit without making changes
        }
        // Set the consecutive slots for the first time
        setBooking_time(nextSlots); // Clear all previous selections and set only the new consecutive slots
        setCorporateInitialSelectionDone(true); // Mark the initial selection as done
        setCorporateInitialSelectionSlots(nextSlots);
    } else {
        // Allow single slot selection after the initial consecutive slots have been selected
        setBooking_time((prevBookingTime) => {
            let newBookingTime = [...prevBookingTime];

            
    if (corporateInitialSelectionSlots.includes(selectedTimeSlot)) {
        newBookingTime = []; // Clear all selections
        setCorporateInitialSelectionDone(false); // Reset the initial selection state
        setCorporateInitialSelectionSlots([]); // Clear the initial selection slots
    } else if (prevBookingTime.includes(selectedTimeSlot)) {
        // If the time slot is already selected, unselect it (independent slot)
        newBookingTime = newBookingTime.filter(slot => slot !== selectedTimeSlot);
    }
    //  else {
    //     // If the time slot is not selected, select it (independent slot)
    //     newBookingTime.push(selectedTimeSlot);
    // }

    else {
        const firstSelectedSlot = newBookingTime[0];
        const lastSelectedSlot = newBookingTime[newBookingTime.length - 1];
        const firstSelectedIndex = bookingAvailableTimeSlots.indexOf(firstSelectedSlot);
        const lastSelectedIndex = bookingAvailableTimeSlots.indexOf(lastSelectedSlot);

        if (selectedSlotIndex === firstSelectedIndex - 1 || selectedSlotIndex === lastSelectedIndex + 1) {
            newBookingTime.push(selectedTimeSlot);
            newBookingTime.sort((a, b) => bookingAvailableTimeSlots.indexOf(a) - bookingAvailableTimeSlots.indexOf(b));
        } else {
            alert("Please select consecutive time slots.");
        }
    }
            return newBookingTime;
        });
    }
}

            else{


                
                
        // setBooking_time((prevBookingTime) =>
        //     prevBookingTime.includes(selectedTimeSlot)
        //         ? prevBookingTime.filter((timeSlot) => timeSlot !== selectedTimeSlot)
        //         : [...prevBookingTime, selectedTimeSlot]
        // );


        setBooking_time((prevBookingTime) => {
            let newBookingTime = [...(prevBookingTime || [])]; // Ensure it's an array
        
            if (newBookingTime.includes(selectedTimeSlot)) {
                // If the time slot is already selected, unselect it
                newBookingTime = newBookingTime.filter(slot => slot !== selectedTimeSlot);
            } else {
                // Check if the new selection is consecutive
                if (newBookingTime.length === 0) {
                    // Allow first selection freely
                    newBookingTime.push(selectedTimeSlot);
                } else {
                    const firstSelectedSlot = newBookingTime[0];
                    const lastSelectedSlot = newBookingTime[newBookingTime.length - 1];
                    const firstSelectedIndex = bookingAvailableTimeSlots.indexOf(firstSelectedSlot);
                    const lastSelectedIndex = bookingAvailableTimeSlots.indexOf(lastSelectedSlot);
        
                    if (selectedSlotIndex === firstSelectedIndex - 1 || selectedSlotIndex === lastSelectedIndex + 1) {
                        // Allow only consecutive slot selection
                        newBookingTime.push(selectedTimeSlot);
                        newBookingTime.sort((a, b) => bookingAvailableTimeSlots.indexOf(a) - bookingAvailableTimeSlots.indexOf(b));
                    } else {
                        alert("Please select consecutive time slots.");
                    }
                }
            }
        
            return newBookingTime; // Return updated array
        });

            }

    };


    function renderEventContent(eventInfo) {
        const { event } = eventInfo;
        
        const backgroundColor = event.backgroundColor || '#03a9f3'; // Default color
    
        return (
            <div
                style={{
                    backgroundColor,
                    color: event.textColor || '#ffffff',
                    padding: '6px',
                    borderRadius: '5px',
                    textAlign: 'left',
                    width: '100%',
                    boxSizing: 'border-box',
                    overflowWrap: 'break-word', 
                    whiteSpace: 'normal', 
                    
                    
                }}
            >
                {event.title}
            </div>
        );
    }
    const handleDateChange = (e) => {

        const selectedDate = e.target.value;
        setDate(selectedDate);
        axios.get(`${API_URL}/booked-appointments`, { params: { selectedDate } })
            .then(response => {
                const bookedTimes = response.data.map(time => {
                    const [hour, minute] = time.split(':');
                    const hour12 = (parseInt(hour) % 12) || 12;
                    const ampm = parseInt(hour) < 12 ? 'AM' : 'PM';
                    return `${hour12}:${minute} ${ampm}`;
                });

                const availableTimes = generateTimeSlots(bookedTimes);
                // console.log(bookedTimes);
            })
            .catch(error => {
                console.error('Error fetching available date-time pairs:', error);
            });
    };

    const generateTimeSlots = (bookedTimes) => {
        // Generate time slots from 9 AM to 4 PM
        const startTime = 9;
        const endTime = 16;
        const timeSlots = [];

        for (let hour = startTime; hour <= endTime; hour++) {
            const formattedHour = hour % 12 || 12;
            const ampm = hour < 12 ? 'AM' : 'PM';
            const timeSlot = `${formattedHour}:00 ${ampm}`;
            timeSlots.push(timeSlot);
        }


        // console.log(timeSlots.filter(timeSlot => !timeSlot.includes(bookedTimes)))

        const availableTimeSlots = timeSlots.filter(timeSlot => !bookedTimes.includes(timeSlot));
        setAvailableTimeSlot(availableTimeSlots);
        return availableTimeSlots;
    };



    async function bookGame(e) {
        e.preventDefault();
        setLoading(true);


        let errors = {}; // Object to store all validation errors

     
    
        if (selectedBirthdayPackage) {
            if (Number(getTotalSelectedFoods()) < Number(birthday_packages.food_quantity)) {
                errors.food_details = `Please select ${birthday_packages.food_quantity} food options.`;
            }
            if (Number(getTotalSelectedDrinks()) < Number(birthday_packages.drink_quantity)) {
                errors.drink_details = `Please select ${birthday_packages.drink_quantity} drink options.`;
            }
        }
    
        if (selectedCorporatePackage) {
            if (Number(getTotalSelectedFoods()) < Number(corporate_packages.food_quantity)) {
                errors.food_details = `Please select ${corporate_packages.food_quantity} food options.`;
            }
            if (Number(getTotalSelectedDrinks()) < Number(corporate_packages.drink_quantity)) {
                errors.drink_details = `Please select ${corporate_packages.drink_quantity} drink options.`;
            }
        }
    
        if (Object.keys(errors).length > 0) {
            setBookingErrorList(errors); // Overwrite previous errors
            setLoading(false);
            return;
        } else {
            setBookingErrorList({}); // Clear errors if validation passes
        }
    
   

    
        try {
            const formData = new FormData();
            formData.append("location_id", selectedGameLocation);
            formData.append("game_id", selectedGame);
            formData.append("game_type_id", selectedGameType);
            formData.append("booked_date", booking_date);
            formData.append("booked_time", JSON.stringify(booking_time));
            formData.append("booked_by", userContext.userDetails.id);
            formData.append("firstname", firstname);
            formData.append("lastname", lastname);
            formData.append("phone", phone);
            formData.append("email", email);
            formData.append("no_of_adults", adults_count);
            formData.append("no_of_children", kids_count);
            formData.append("hst", hst);
            formData.append("grand_total", grand_total);
            formData.append("payment_due", grand_total - amount_paid); // Add due amount
            formData.append("deposit_amount", deposit_amount);
            formData.append("deposit_details", deposit_details);
            formData.append("no_of_slots", booking_time.length);
            formData.append("cart_details", JSON.stringify(cart_details));
            formData.append("amount_paid", amount_paid);
            formData.append("selectedPackageType", selectedPackageType);
            formData.append("selectedGameType", selectedGameType);
            formData.append("selectedBirthdayPackage", selectedBirthdayPackage);
            formData.append("selectedCorporatePackage", selectedCorporatePackage);
            formData.append("min_players", minPlayers);
            formData.append("max_players", maxPlayers);
            formData.append("total_players", Number(adults_count) + Number(kids_count));
            formData.append("payment_method", payment_method);
            formData.append("discount_details", JSON.stringify(discountDetails));
            formData.append("discount_amount", discountAmount);
            formData.append("promo_details", JSON.stringify(promoDetails));
            formData.append("promo_amount", promoAmount);

            if (selectedBirthdayPackage) {
                formData.append("is_package", 1);
                formData.append("main_package_id", 1);
                formData.append("sub_package_id", selectedBirthdayPackage);
                formData.append("package_price", basic_price);
                formData.append("game_package_id", selectedBirthdayPackage);
                formData.append("birthday_kid_name", birthdayKid);
                // formData.append("food_details", selectedFoods);

                const formattedEventFoods = {};
                const formattedEventDrinks = {};
// Loop through selected foods and format them into an object
Object.entries(selectedFoods).forEach(([food, quantity]) => {
    if (quantity > 0) {  // Only append foods that have been selected
      formattedEventFoods[food] = String(quantity); // Convert quantity to string to ensure it's saved as string
    }
  });

  // Loop through selected drinks and format them into an object
  Object.entries(selectedDrinks).forEach(([drink, quantity]) => {
    if (quantity > 0) {  // Only append drinks that have been selected
      formattedEventDrinks[drink] = String(quantity); // Convert quantity to string
    }
  });

  // Prepare form data for submission

  formData.append("food_details", JSON.stringify(formattedEventFoods)); // Now storing as a proper JSON object
  formData.append("drink_details", JSON.stringify(formattedEventDrinks)); // Same here for drinks

        
               
                // formData.append("drink_details", selectedDrinks);
                formData.append("game_count", game_count);
                formData.append("min_game", min_game);
                formData.append("max_players_in_a_slot", birthday_packages.max_players_in_a_slot);
                formData.append("cost", birthdayPrice.price);
                formData.append("subtotal", birthdayPrice.price);
                formData.append("extraPlayerPrice", extraPlayerPrice);
                formData.append("extraGamePrice", extraGamePrice);
                } else  if (selectedCorporatePackage) {
                formData.append("is_package", 1);
                formData.append("main_package_id", 2);
                formData.append("sub_package_id", selectedCorporatePackage);
                formData.append("package_price", basic_price);
                formData.append("corporate_package_id", selectedCorporatePackage);
                // formData.append("food_details", selectedEventFoods);
                // formData.append("drink_details", selectedEventDrinks);

                const formattedEventFoods = {};
                const formattedEventDrinks = {};
// Loop through selected foods and format them into an object
Object.entries(selectedFoods).forEach(([food, quantity]) => {
    if (quantity > 0) {  // Only append foods that have been selected
      formattedEventFoods[food] = String(quantity); // Convert quantity to string to ensure it's saved as string
    }
  });

  // Loop through selected drinks and format them into an object
  Object.entries(selectedDrinks).forEach(([drink, quantity]) => {
    if (quantity > 0) {  // Only append drinks that have been selected
      formattedEventDrinks[drink] = String(quantity); // Convert quantity to string
    }
  });

  // Prepare form data for submission

  formData.append("food_details", JSON.stringify(formattedEventFoods)); // Now storing as a proper JSON object
  formData.append("drink_details", JSON.stringify(formattedEventDrinks)); // Same here for drinks

     
                formData.append("game_count", eventGame_count);
                formData.append("min_game", min_game);
                formData.append("max_players_in_a_slot", corporate_packages.max_players_in_a_slot);
                formData.append("cost", corporatePrice.price);
                formData.append("subtotal", corporatePrice.price);
                formData.append("extraPlayerPrice", extraPlayerPrice);
                formData.append("extraGamePrice", extraGamePrice);
        

            } 
            
            else {
                formData.append("cost", timeSlotDetails.price);
                formData.append("subtotal", timeSlotDetails.price);
                formData.append("food_details", JSON.stringify({})); // Empty object if no food details
                formData.append("drink_details", JSON.stringify({})); // Empty object if no drink details
               
            }


            const bookingResponse = await axios.post(`${API_URL}/save-booked-slots`, formData);
    
            // Prepare email data after successful booking
            const emailData = await prepareEmailData(bookingResponse.data.booking);
    

            // API call to send email
            const emailResponse = await axios.post(`${API_URL}/send-email`, emailData);

        
    
            Swal.fire({
                icon: "success",
                // text: emailResponse.data.message
                text: 'Booked Successfully! Confirmation Email sent to ' + emailData.to
            });
    
            resetBooking();
            fetchEvents();
            setBookingErrorList([]);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (error) {
            setBookingErrorList(error.response?.data?.validate_err || []);
            Swal.fire({
                text: error.response?.data?.message || 'Something went wrong!',
                icon: "error"
            });
            console.error('Full error:', error);

        } finally {
            setLoading(false);
        }
    }
    
    // const formatBookedTime = (bookedTime) => {
    //     try {
    //       const timeSlots = JSON.parse(bookedTime); // Assuming bookedTime is a JSON string
    //       if (Array.isArray(timeSlots) && timeSlots.length > 0) {
    //         const startTime = timeSlots[0].split(' - ')[0];
    //         const endTime = timeSlots[timeSlots.length - 1].split(' - ')[1];
    //         // Convert to moment objects and format them
    //         const formattedStartTime = moment(startTime, 'hh:mm A').format('h:mm A');
    //         const formattedEndTime = moment(endTime, 'hh:mm A').format('h:mm A');
    //         return `${formattedStartTime} - ${formattedEndTime}`;
    //       }
    //       return 'No time slots available';
    //     } catch (error) {
    //       console.error("Error parsing booked time:", error);
    //       return 'Invalid time format';
    //     }
    //   };



    const formatBookedTime = (bookedTime) => {
        try {
          const timeSlots = JSON.parse(bookedTime); // Assuming bookedTime is a JSON string
          if (Array.isArray(timeSlots) && timeSlots.length > 0) {
            
            // Sort time slots by start time before merging
            const sortedSlots = timeSlots.sort((a, b) => {
              const [startA] = a.split(' - ');
              const [startB] = b.split(' - ');
              return moment(startA, 'hh:mm A').diff(moment(startB, 'hh:mm A'));
            });
      
            let mergedSlots = [];
            let currentRangeStart = null;
            let currentRangeEnd = null;
      
            sortedSlots.forEach((slot, index) => {
              const [startTime, endTime] = slot.split(' - ');
              const currentStartTime = moment(startTime, 'hh:mm A');
              const currentEndTime = moment(endTime, 'hh:mm A');
      
              if (!currentRangeStart) {
                // First time slot, initialize the range
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              } else if (currentRangeEnd.isSame(currentStartTime)) {
                // If the current slot starts when the last one ended, extend the range
                currentRangeEnd = currentEndTime;
              } else {
                // If the current slot does not continue from the last one, close the current range and start a new one
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              }
      
              // If it's the last slot, push the current range
              if (index === sortedSlots.length - 1) {
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
              }
            });
      
            return mergedSlots.join(', '); // Join the merged slots with a comma
          }
          return 'No time slots available';
        } catch (error) {
          //console.error("Error parsing booked time:", error);
          return 'Invalid time format';
        }
      };
      


    function convertPlainTextToHTML(text) {
        return text
            .replace(/\n/g, '<br>')  // Replace line breaks with <br>
            .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length));  // Replace multiple spaces with &nbsp;
    }

    async function prepareEmailData(bookingDetails) {
        
        const consentFormUrl = `${API_BASE_URL}/consent-form-page/${bookingDetails.booking_ref_id}/${bookingDetails.booking_id}`;
        const formattedBookedTime = formatBookedTime(bookingDetails.booked_time);

        const qrCodeFilename = `${bookingDetails.booking_ref_id}.png`; // Use the same filename for consistency

        // Generate and upload QR code image
        const qrCodeImageUrl  = await generateQRCodeImage(consentFormUrl, qrCodeFilename);
    

        // Await the QR code data URL
        // let qrCodeDataUrl;
        // try {
        //     qrCodeDataUrl = await generateQRCodeDataUrl(consentFormUrl);
        //     console.log(qrCodeDataUrl);
        // } catch (error) {
        //     qrCodeDataUrl = null; // Handle the error as needed
        // }
    
        // Convert the plain text template to HTML
        const message = convertPlainTextToHTML(emailData.message)
            .replace('[customer_name]', `${bookingDetails.firstname} ${bookingDetails.lastname}`)
            .replace('[event_date]', moment(bookingDetails.booked_date).format('D MMMM YYYY'))
            .replace('[event_time]', formattedBookedTime)  // Joining the times array into a string
            .replace('[location]', bookingDetails.location_name)
            .replace('[number_of_players]', bookingDetails.total_players)
            .replace('[package_name]',  bookingDetails.game_type_name ||
                (bookingDetails.package_name === 'Corporate' 
                  ? `${bookingDetails.package_name} - ${bookingDetails.corporate_package_name}`
                  : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`
                ))
            .replace('[consent_form_link]', `<a href="${consentFormUrl}">Click here to complete the consent form</a>`)
            .replace('[qr_code]', qrCodeImageUrl ? `<img src="${qrCodeImageUrl}" alt="QR Code for Consent Form" />` : 'QR code not available');
    

        return {
            booking_id: bookingDetails.booking_id,
            to: bookingDetails.email,
            subject: emailData.subject,
            message ,// This is now HTML formatted
             bcc: 'booking.lasercombat@hotmail.com', 
        };
    }
    
    function generateQRCodeDataUrl(url) {
        // Return a promise that resolves with the QR code Data URL
     
        return QRCode.toDataURL(url, { width: 150 });
    }

    async function generateQRCodeImage(url, filename,size = 150) {
        try {
            // Generate QR Code as Data URL
            const dataUrl = await QRCode.toDataURL(url,  { width: size, height: size });
    
            // Convert Data URL to Blob
            const blob = await (await fetch(dataUrl)).blob();
            
            // Upload Blob to your server and get the URL
            const imageUrl = await uploadQRCodeImage(blob, filename);
            
           
            return imageUrl;
        } catch (error) {
            console.error('Error generating QR code image:', error);
            return null;
        }
    }
    
    async function uploadQRCodeImage(blob, filename) {
        const formData = new FormData();
        formData.append('file', blob, filename);
    
        try {
            const response = await axios.post(`${API_URL}/upload-qr-code`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    
            if (response.status !== 200) {
                throw new Error('Failed to upload QR code image');
            }
    
            const result = response.data; 
           
            return result.imageUrl;         
        } catch (error) {
            console.error('Error uploading QR code image:', error);
            return null;
        }
    }




    const handleCloseEmailModal = () => setShowEmailModal(false);

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setEmailData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
      e.preventDefault();
      setLoading(true);

      const formData = {        
          ...emailData,
      };
      // Implement email sending functionality here
    //   console.log('Email sent with data:', formData);
    
        axios.post(`${API_URL}/send-email`, formData)
        .then(() => {
    
         setLoading(false);
         showToast("Email sent successfully!");
         handleCloseEmailModal();
       //  setEmailErrorList({ to: '', subject: '', message: '' });
      //    resetEmail();
         
        })
        .catch((error) => {
          setLoading(false);
         // setEmailErrorList(error.response.data.validate_err);
          
         console.error('Error sending email:', error.response.data.message);
        });





  };

  




    const resetBooking = () => {
        setBooking_date("");
        setFirstname('');
        setLastname('');
        setPhone('');
        setEmail('');
        setBooking_time([]);
        setKids_count(0);
        setAdults_count(0);
        setTimeSlotDetails((prev) => ({ ...prev, price: 0 }));
        setBirthdayPrice((prev) => ({ ...prev, price: 0 }));
        setNote('');
        setSelectedGameType('');
        setSelectedPackageType('');
        setSelectedBirthdayPackage('');
        setSelectedCorporatePackage('');
        setBirthdayKid('');
        setSelectedFoods('');
        setSelectedDrinks('');
        setSelectedEventFoods('');
        setSelectedEventDrinks('');
        setBirthdayKid('');
        setBookingAvailableTimeSlots([]);
        setGame_count('');
        setGrand_total(0);
        setDeposit_amount(0);
        setExtraGamePrice(0);
        setExtraPlayerPrice(0);
        setBasic_price(0);
        setAmount_paid(0);
        setBookingErrorList([]);
        setPayment_method("");
        setTotalPlayersErrorList('');
        setGameCountErrorList('');
        setEventGameCountErrorList('');
        setDiscountAmount(0);
        setDiscountDetails([]);
        setPromoAmount(0);
        setPromoDetails([]);
        setCart_details('');
        setHst(0);
        
    };




    const handleDateClick = (arg) => {
    // const today = new Date().toLocaleDateString("en-CA", {timeZone: 'America/Toronto'});

     //  const today = moment().tz(timezone).format('YYYY-MM-DD');
 

    
if (arg.dateStr < today) {
            return; // Ignore clicks on past dates
        }
        if (isHoliday(arg.dateStr)) {
            return;
        }

        //resetBooking();
        setSelectedDate(arg.dateStr);
        handleBookingDateChange(arg.dateStr);

    };

    const handleFoodOptionChange = (e) => {
        const value = e.target.value;
      //  let updatedLocations = selectedLocations.split(',').map(Number); // Ensure it's an array
        let updatedFoods = [...selectedFoods];
        if (e.target.checked) {
            updatedFoods = [...updatedFoods, value];
        } else {
            updatedFoods = updatedFoods.filter((id) => id !== value);
        }
      
        setSelectedFoods(updatedFoods); // Convert back to a comma-separated string
      };

      const handleDrinkOptionChange = (e) => {
        const value = e.target.value;
      //  let updatedLocations = selectedLocations.split(',').map(Number); // Ensure it's an array
        let updatedDrinks = [...selectedDrinks];
        if (e.target.checked) {
            updatedDrinks = [...updatedDrinks, value];
        } else {
            updatedDrinks = updatedDrinks.filter((id) => id !== value);
        }
      
        setSelectedDrinks(updatedDrinks); // Convert back to a comma-separated string
      };

      const handleEventFoodOptionChange = (e) => {
        const value = e.target.value;
      //  let updatedLocations = selectedLocations.split(',').map(Number); // Ensure it's an array
        let updatedFoods = [...selectedEventFoods];
        if (e.target.checked) {
            updatedFoods = [...updatedFoods, value];
        } else {
            updatedFoods = updatedFoods.filter((id) => id !== value);
        }
      
        setSelectedEventFoods(updatedFoods); // Convert back to a comma-separated string
      };

      const handleEventDrinkOptionChange = (e) => {
        const value = e.target.value;
      //  let updatedLocations = selectedLocations.split(',').map(Number); // Ensure it's an array
        let updatedDrinks = [...selectedEventDrinks];
        if (e.target.checked) {
            updatedDrinks = [...updatedDrinks, value];
        } else {
            updatedDrinks = updatedDrinks.filter((id) => id !== value);
        }
      
        setSelectedEventDrinks(updatedDrinks); // Convert back to a comma-separated string
      };



      const handleAmountPaidChange = (value) => {
        const depositAmount = deposit_amount; // Replace with the actual deposit amount value
        const grandTotal = grand_total; // Replace with the actual grand total value
    
        setAmount_paid(value);
    
        // Validate the amount paid
        if (Number(value) < depositAmount) {
            // setBookingErrorList(prevState => ({
            //     ...prevState,
            //     amount_paid: `Amount paid should not be less than ${depositAmount}.`
            // }));
        } else if (Number(value) > grandTotal) {
            setBookingErrorList(prevState => ({
                ...prevState,
                amount_paid: `Amount paid should not exceed ${grandTotal}.`
            }));
        } else {
            // Clear the error if valid
            setBookingErrorList(prevState => ({
                ...prevState,
                amount_paid: ''
            }));
        }
    };
    

    const handleAddDiscount = () => {
        setDiscountType('');
        setDiscountValue('');
        setDiscountDescription('');
        setShowDiscountModal(true);
      };

      const handleApplyPromo = () => {
        setPromoCode('');
        setShowPromoModal(true);
      };
      
    //   const handleApplyPromo = async () => {
    //     try {
    //     //   const res = await axios.post("/api/validate-promo", {
    //     //     code: promoCode,
    //     //     game_type_id,
    //     //     location_id,
    //     //     date,
    //     //   });
    //     //   if (res.data.valid) {
    //     //     setDiscount(res.data.discount_amount);
    //     //   } else {
    //     //     alert("Invalid or expired promo code");
    //     //     setDiscount(0);
    //     //   }
    //     } catch (error) {
    //       console.error("Promo code error", error);
    //     }
    //   };


    //   const applyDiscount = () => {
    //     const amount = Number(discountValue);
      
    //     const newDiscount = {
    //       type: discountType,
    //       value: amount,
    //       description: discountDescription,
    //     };
      
    //     // Add new discount to list
    //     setDiscountDetails(prev => [...prev, newDiscount]);
      
    //     // Close modal
    //     setShowDiscountModal(false);
      
    //     // Clear form fields
    //     setDiscountType('');
    //     setDiscountValue('');
    //     setDiscountDescription('');
    //   };


    
    const applyDiscount = () => {
  const amount = Number(discountValue);

  const subtotal = (
          selectedCorporatePackage && corporatePrice?.price
            ? Number(corporatePrice.price)
            : selectedBirthdayPackage && birthdayPrice?.price
            ? Number(birthdayPrice.price)
            : timeSlotDetails?.price
            ? Number(timeSlotDetails.price)
            : 0
        );

  // Calculate actual discount amount
  const discountAmount = discountType === 'percentage'
    ? (subtotal * amount) / 100
    : amount;

  const newDiscount = {
    type: discountType,
    value: amount,
    description: discountDescription,
    amount: parseFloat(discountAmount.toFixed(2)), 
  };

  // Add to list
  const updatedDiscounts = [...discountDetails, newDiscount];
  setDiscountDetails(updatedDiscounts);

  // Sum all discounts
  const totalDiscount = Math.min(
    updatedDiscounts.reduce((acc, d) => acc + (d.amount || 0), 0),
    subtotal
  );

  setDiscountAmount(parseFloat(totalDiscount.toFixed(2)));

  // Close modal & reset
  setShowDiscountModal(false);
  setDiscountType('');
  setDiscountValue('');
  setDiscountDescription('');
};


    //   const applyDiscount = () => {
    //     const amount = Number(discountValue);
      
    //     const newDiscount = {
    //       type: discountType,
    //       value: amount,
    //       description: discountDescription,
          
    //     };
      
    //     // Add new discount to list
    //     const updatedDiscounts = [...discountDetails, newDiscount];
    //     setDiscountDetails(updatedDiscounts);
      
    //     // Calculate subtotal
    //     const subtotal = (
    //       selectedCorporatePackage && corporatePrice?.price
    //         ? Number(corporatePrice.price)
    //         : selectedBirthdayPackage && birthdayPrice?.price
    //         ? Number(birthdayPrice.price)
    //         : timeSlotDetails?.price
    //         ? Number(timeSlotDetails.price)
    //         : 0
    //     );
      
    //     // Sum all discounts
    //     let totalDiscount = 0;
    //     updatedDiscounts.forEach(discount => {
    //       if (discount.type === 'percentage') {
    //         totalDiscount += (subtotal * discount.value) / 100;
    //       } else {
    //         totalDiscount += discount.value;
    //       }
    //     });
      
    //     // Ensure discount does not exceed subtotal
    //     totalDiscount = Math.min(totalDiscount, subtotal);
    //     setDiscountAmount(totalDiscount); // Assuming you have this state
      
    //     // Close modal
    //     setShowDiscountModal(false);
      
    //     // Clear form fields
    //     setDiscountType('');
    //     setDiscountValue('');
    //     setDiscountDescription('');
    //   };

 const applyPromoCode = () => {
  const selected = promoCodeList.find(code => code.code_name === promoCode);
  if (!selected) return;

  const subtotal = (
    selectedCorporatePackage && corporatePrice?.price
      ? Number(corporatePrice.price)
      : selectedBirthdayPackage && birthdayPrice?.price
      ? Number(birthdayPrice.price)
      : timeSlotDetails?.price
      ? Number(timeSlotDetails.price)
      : 0
  );

  const promoType = Number(selected.is_percentage) ? 'percentage' : 'amount';
  const promoValue = Number(selected.value_amount);

  // Calculate this promo's discount amount
  const amount = promoType === 'percentage'
    ? (subtotal * promoValue) / 100
    : promoValue;

  const newPromo = {
    code_name: selected.code_name,
    type: promoType,
    value: promoValue,
    amount: amount.toFixed(2), //  store exact discount amount
  };

  const updatedPromos = [...promoDetails, newPromo];

  // Recalculate total promo amount from updatedPromos
  const totalPromoAmount = updatedPromos.reduce((acc, promo) => {
    return acc + (promo.amount ? parseFloat(promo.amount) : 0);
  }, 0);

  const cappedPromoAmount = Math.min(totalPromoAmount, subtotal);

  setPromoDetails(updatedPromos);
  setPromoAmount(parseFloat(cappedPromoAmount.toFixed(2)));
  setShowPromoModal(false);
};


     
//      const applyPromoCode = () => {
//   const subtotal = (
//     selectedCorporatePackage && corporatePrice?.price
//       ? Number(corporatePrice.price)
//       : selectedBirthdayPackage && birthdayPrice?.price
//       ? Number(birthdayPrice.price)
//       : timeSlotDetails?.price
//       ? Number(timeSlotDetails.price)
//       : 0
//   );

//   const selected = promoCodeList.find(code => code.code_name === promoCode);
//   if (!selected) return;

//   // Build the new promo entry
//   const newPromo = {
//     code_name: selected.code_name,
//     type: Number(selected.is_percentage) ? 'percentage' : 'amount',
//     value: Number(selected.value_amount),
//   };

//   // Combine with existing promos
//   const updatedPromos = [...promoDetails, newPromo];

//   // Recalculate total promo discount from all promos
//   let totalPromoAmount = 0;
//   updatedPromos.forEach(promo => {
//     if (promo.type === 'percentage') {
//       totalPromoAmount += (subtotal * promo.value) / 100;
//     } else {
//       totalPromoAmount += promo.value;
//     }
//   });

//   // Cap total promo discount to avoid exceeding subtotal
//   const cappedPromoAmount = Math.min(totalPromoAmount, subtotal);

//   // Update state
//   setPromoDetails(updatedPromos);
//   setPromoAmount(cappedPromoAmount);
//   setShowPromoModal(false);
// };

      
      

      const handleCloseDiscountModal = () => setShowDiscountModal(false);
      const handleClosePromoModal = () => setShowPromoModal(false);


      const handleRemoveDiscount = (indexToRemove) => {
        setDiscountDetails(prev => {
          const updated = prev.filter((_, i) => i !== indexToRemove);
          return updated;
        });
      };
      
      const handleRemovePromo = (index) => {
        const updatedPromoDetails = promoDetails.filter((_, i) => i !== index);
        setPromoDetails(updatedPromoDetails);
      };
      
    return (
        <div>
            <SideNav />
            <TopBar />
            {isLoading ?
                <div className="loader-container" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: "0", left: "0", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", zIndex: "9999" }}>
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                        </div>
                    </div>
                </div> : null}

            <div className="right_panel position contact_section vh-100" id="right_panel">
                <div className="main_title d-flex align-items-center">
                    <h1><i className="bi bi-calendar-check"></i> Manual Booking</h1>
                </div>

                <div className="content_wrapper pt-0">
                    <div className="vm_content_box_1">
                        <div className="title">
                            <h2>Booking details</h2>
                        </div>
                        <div className='row px-4'>


                            <div class="content col-md-2">
                                <div class="form-group pt-3 pb-2">

                                    <select class="form-select" id="selectedGameLocation" name="selectedGameLocation" value={selectedGameLocation} onChange={handleGameAvailableLocationChange}>
                                        <option value="">Select game location</option>
                                        {filteredLocations.map((location) => (
                                            <option key={location.id} value={location.id}>
                                                {location.location_name}
                                            </option>
                                        ))}
                                    </select>   {!selectedGameLocation && (
                                        <span class="text-danger">{error_list.location_id}</span>)}
                                </div>
                            </div>


                            <div class="content col-md-2 ">
                                <div class="form-group pt-3 pb-2">

                                    <select className="form-select me-2" id="game" name="game" value={selectedGame} onChange={handleGameChange}>
                                        <option value="">Select a game</option>
                                        {game_available.map((game) => (
                                            <option key={game.id} value={game.id}>
                                                {game.name}
                                            </option>
                                        ))}
                                    </select> {!selectedGame && (
                                        <span class="text-danger">{error_list.game_id}</span>)}
                                </div>
                            </div>





                        </div>
                        <div className='row'>


                            <div className='col'>
                                <div className="calendar-responsive content pt-3 pb-5 mb-5" id="calender" style={{ boxShadow: "0px 0px 21px 2px rgba(0, 0, 0, 0.18)", backgroundColor: "white", marginTop: "20px", width: '100%', overflowX: 'auto' }}  >


                                    <FullCalendar
                                        plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
                                        initialView="dayGridMonth"
                                        events={[...filteredEvents, ...getHolidayEvents()]}
                                        headerToolbar={{
                                            left: 'prev,next today',
                                            center: 'title',
                                            right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                                        }}
                                        themeSystem="bootstrap-premium"
                                        height="auto"
                                        contentHeight="auto"
                                        eventColor="#03a9f3" // Set event color
                                        eventTextColor="#ffffff" // Set event text color
                                        dateClick={handleDateClick}
                                        eventContent={renderEventContent} 
                                        dayCellDidMount={(info) => {
                                          //  const today = new Date().toISOString().split('T')[0]; // Current date
                                         
                                            // const today = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Toronto'});
                                            //   const today = moment().tz(timezone).format('YYYY-MM-DD');
                                            // const cellDate = moment(info.date).format('YYYY-MM-DD');



//                                          if (cellDate < today) {
//     console.log('Marking as past:', cellDate);
//     info.el.classList.add('fc-day-past');
//   } else {
//     console.log('Not marking:', cellDate);
//   }
}}
                                        
                                                   
                                        eventClick={handleEventClick}
                                      
                                    />

                                </div>
                            </div>

                            {view === 'form' && (
                                booking_date && (
                                    <div className='col-md-4'>

                                        <div class="py-3 mt-4 border bg-white">
                                            <h3 class="vm_font_semi_bold border-bottom mb-3 px-3 pb-2">
                                                Booking Form
                                            </h3>



                                            <div className="container">
    <div className="col">
        {/* Box 1 */}
        <div className="col-md-12">
            <div className="form-box py-4 px-3 bg-light border  shadow-sm mb-4">
                {/* <h5 className="box-title mb-4">Personal Information</h5> */}
                
                <div className="col-md-12">

{/* <div className="col-md-12">
    <button className="btn btn-primary" onClick={() => { setShowEmailModal(true); console.log('clicked', showEmailModal); }}>
        Send Email
    </button>


    <Modal show={showEmailModal} onHide={handleCloseEmailModal}>
    <Modal.Header closeButton>
        <Modal.Title>Send Email</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <div className="alert alert-success text-center">
    <i className="bi bi-check-circle h1"></i>  Successfully Booked! Send a confirmation email to the customer.
        </div>
        <Form onSubmit={handleSubmit}>
            <Form.Group controlId="emailTo" className="form-group mt-3 ">
                <label>To</label>
                <Form.Control 
                    type="email" 
                    name="to" 
                    value={emailData.to} 
                    onChange={handleInputChange} 
                    readOnly
                />
                <span className="text-danger">{email_error_list.to}</span>
            </Form.Group>
            <Form.Group controlId="emailSubject"  className="form-group mt-3 ">
                <Form.Label>Subject</Form.Label>
                <Form.Control 
                    type="text" 
                    name="subject" 
                    value={emailData.subject} 
                    onChange={handleInputChange} 
                />
                <span className="text-danger">{email_error_list.subject}</span>
            </Form.Group>
            <Form.Group controlId="emailMessage"  className="form-group mt-3 ">
                <Form.Label>Message</Form.Label>
                <Form.Control 
                    as="textarea" 
                    rows={8} 
                    name="message" 
                    value={emailData.message} 
                    onChange={handleInputChange} 
                />
                <span className="text-danger">{email_error_list.message}</span>
            </Form.Group>

            <div class="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{ padding:'10px 10px 30px 10px' }}>
                <label className="vm_cursor_pointer" htmlFor="image">
                    <i className="bi bi-card-image h2"></i>
                </label>
                <input 
                    className="d-none" 
                    type="file" 
                    name="image" 
                    id="image" 
                    multiple 
                    onChange={onSelectImages} 
                />
                <select 
                    className="form-select ms-3 form-select-sm" 
                    name="template" 
                    id="template" 
                    value={template} 
                    onChange={handleTemplateChange}
                >
                    <option value="">Select Template</option>
                    {email_template.map((item) => (
                        <option value={item.template_name} key={item.template_name}>
                            {item.template_name}
                        </option>
                    ))}
                </select>
            </div>

            <div className="d-flex align-items-center justify-content-between mt-2 mb-3">
                <button className="btn btn-sm btn_secondary text-white ms-auto" type="submit">
                    Send Email
                </button>
            </div>
            </div>
        </Form>
    </Modal.Body>
</Modal>
</div> */}

              
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group ">
                                                                    <label htmlFor="date"> Date</label>
                                                                    <div class="d-flex input_wrapper">
                                                                        <div class="icon_wrapper">
                                                                            <i class="bi bi-calendar2-plus icon"></i>
                                                                        </div>

                                                                        <input type="date" id="booking_date" value={booking_date} className="form-control" onChange={(e) => handleBookingDateChange(e.target.value)} readOnly />


                                                                    </div>
                                                                    <span class="text-danger">{bookingErrorList.booked_date}</span>
                                                                </div>
                                                            </div>


                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label htmlFor="selectedPackageType">Select Package Type</label>
                                                                    <select
                                                                        className="form-select"
                                                                        id="selectedPackageType"
                                                                        name="selectedPackageType"
                                                                        value={selectedPackageType}
                                                                        onChange={(e) => {setSelectedPackageType(e.target.value); setSelectedGameType('');setSelectedBirthdayPackage('');setSelectedCorporatePackage('');
                                                                            if(selectedPackageType === 'birthday_package')
                                                                            {fetchGamePackages(1)}
                                                                            else if(selectedPackageType == 'corporate_event')
                                                                            {fetchCorporateEvents(2)}
                                                                        }}
                                                                        
                                                                    >
                                                                        <option value="">Select Package Type</option>
                                                                          <option value="laser_tag_package">Court Package</option>
                                                                        {/* <option value="laser_tag_package">Laser Tag package</option>
                                                                        <option value="birthday_package">Birthday Package</option>
                                                                        <option value="corporate_event">Corporate Event</option> */}
                                                                    </select>
                                                                    <span className="text-danger">{bookingErrorList.selectedPackageType}</span>
                                                                </div>
                                                            </div>




                                                            {selectedPackageType === 'laser_tag_package' && (
                                                                <div class="col-md-6">
                                                                    <div class="form-group">
                                                                        <label htmlFor="game_type"> Select Court Room</label>
                                                                        <select class="form-select" id="game_type" name="game_type" value={selectedGameType} onChange={handleGameTypeChange}>
                                                                            <option value="">Select Court Room</option>
                                                                            {game_types.map((game_type) => (
                                                                                <option key={game_type.id} value={game_type.id}>
                                                                                    {game_type.game_type_name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <span class="text-danger">{bookingErrorList.game_type_id}</span>
                                                                    </div>
                                                                </div>
                                                            )}


                                                            {selectedPackageType === 'birthday_package' &&  (
                                                                 <div className='col-md-12'>
                                                                   <div className='row'>
                                                                    <div class="col-md-6">
                                                                    <div class="form-group">
                                                                        <label htmlFor="birthday_package"> Select Birthday Package</label>
                                                                        <select class="form-select" id="birthday_package" name="birthday_package" value={selectedBirthdayPackage} onChange={handleBirthdayPackageChange}>
                                                                            <option value="">Select Birthday package</option>
                                                                            {game_packages.map((game_package) => (
                                                                                <option key={game_package.id} value={game_package.id}>
                                                                                    {game_package.sub_package_name}
                                                                                </option>
                                                                            ))}

                                                                        </select>
                                                                        
                                                                        <span class="text-danger">{bookingErrorList.game_package_id}</span>
                                                                    </div>
                                                                </div>
                                                                { selectedBirthdayPackage &&  
                                                                <div className="col-md-6">
            <div className="form-group">
                <label htmlFor="birthday_kid">Birthday Kid Name</label>
            
                <input type="text" id="birthday_kid" className="form-control" value={birthdayKid} onChange={(e) => setBirthdayKid(e.target.value)} placeholder='Enter birthday Kid name'/>
                <span className="text-danger">{bookingErrorList.birthday_kid}</span>
               
            </div>
        </div>
}
      
        {/* {selectedBirthdayPackage && birthday_packages.min_games && (
    <div className="col-md-6">
        <div className="form-group">
            <label htmlFor="game_count">
                No of Games
              
            </label>
            {birthday_packages.min_games && (
            <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
                *Select minimum {birthday_packages.min_games} games.
            </div>
        )}
            <input
              
                type="number"
                id="game_count"
                className="form-control"
                value={game_count}
                onChange={(e) => setGame_count(e.target.value)}
                min={birthday_packages.min_games}
            
            />
              <span class="text-danger">{gameCountErrorList}</span>
        </div>
    </div>
)} */}
     {/* { selectedBirthdayPackage && (birthday_packages.sub_package_name !== 'Bronze') && ( */}
     {selectedBirthdayPackage && (birthday_packages.food_quantity > 0) && (
  <div className="col-md-6">
    <div className="form-group">
      <label htmlFor="food_details" >Food Details</label>
      {birthday_packages.food_quantity && (
        <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
          *Select {birthday_packages.food_quantity} food options.
        </div>
      )}
      <div className="px-2 py-2 bg-white mt-1 ">
        {foodOptions.map((food, index) => (
          <div
            className="d-flex align-items-center justify-content-between py-1"
            key={index}
           
          >
            <label style={{ marginTop: '5px' }}>{food}</label>
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                   fontWeight: 'bold'
                }}
                onClick={() => handleDecrement(food)}
                disabled={selectedFoods[food] <= 0}
              >
                -
              </button>
              <span className="mx-2" >{selectedFoods[food] || 0}</span>
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                  fontWeight: 'bold'
                }}
                onClick={() => handleIncrement(food)}
                disabled={getTotalSelectedFoods() >= birthday_packages.food_quantity}
              >
                +
              </button>
            </div>
          </div>
        ))}
          {/* <span class="text-danger">{foodErrorList}</span> */}
        <span className="text-danger" >{bookingErrorList.food_details}</span>
      </div>
    </div>
  </div>
)}
    {selectedBirthdayPackage && (birthday_packages.drink_quantity > 0) && (
  <div className="col-md-6">
    <div className="form-group">
      <label htmlFor="food_details" >Drink Details</label>
      {birthday_packages.drink_quantity && (
        <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
          *Select {birthday_packages.drink_quantity} drink options.
        </div>
      )}
      <div className="px-2 py-2 bg-white mt-1 ">
        {drinkOptions.map((drink, index) => (
          <div
            className="d-flex align-items-center justify-content-between py-1"
            key={index}
           
          >
            <label style={{ marginTop: '5px' }}>{drink}</label>
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                   fontWeight: 'bold'
                }}
                onClick={() => handleDrinkDecrement(drink)}
                disabled={selectedDrinks[drink] <= 0}
              >
                -
              </button>
    
              <span className="mx-2" >{selectedDrinks[drink] || 0}</span>
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                  fontWeight: 'bold'
                }}
                onClick={() => handleDrinkIncrement(drink)}
                disabled={getTotalSelectedDrinks() >= birthday_packages.drink_quantity}
              >
                +
              </button>
            </div>
          </div>
        ))}
             {/* <span class="text-danger">{foodErrorList}</span> */}
        <span className="text-danger" >{bookingErrorList.drink_details}</span>
      </div>
    </div>
  </div>
)}





                                                                                {/* {selectedBirthdayPackage && (birthday_packages.drink_quantity > 0) && (
                                                                                    <>
                                                                                        <div className="col-md-6">
                                                                                            <div className="form-group">
                                                                                                <label htmlFor="drink_details">Drink details </label>
                                                                                                {birthday_packages.drink_quantity && (
                                                                                                      <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
                                                                                                        *Select {birthday_packages.drink_quantity} drink options.
                                                                                                    </div>
                                                                                                )}
                                                                                                <div class="px-3 mb-1 bg-white mt-1 pb-1 pt-1">

                                                                                                    <div class="row ">
                                                                                                        {drinkOptions.map((drink, index) => (
                                                                                                            <div className="col-md-10" key={index}>
                                                                                                                <div className="form-group-checkbox d-flex align-items-center justify-content-between">
                                                                                                                    <div className="d-flex align-items-center">

                                                                                                                        <input
                                                                                                                            style={{ boxShadow: "2px 2px #059618", transition: "all .5s ease" }}
                                                                                                                            type="checkbox"
                                                                                                                            value={drink}
                                                                                                                            onChange={handleDrinkOptionChange}
                                                                                                                            disabled={selectedDrinks.length >= birthday_packages.drink_quantity && !selectedDrinks.includes(drink)} />
                                                                                                                        <label style={{ marginTop: '9px' }}>{drink}</label>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>

                                                                                                        ))}     <span className="text-danger">{bookingErrorList.selectedDrinks}</span>
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                            
                                                                                        </div>
                                                                                        </>
)} */}
       
        </div>    </div>


         )}




{selectedPackageType === 'corporate_event' &&  (
   <><div class="col-md-6">
                                                                    <div class="form-group">
                                                                        <label htmlFor="corporate_event"> Select Corporate Package</label>
                                                                        <select class="form-select" id="corporate_event" name="corporate_event" value={selectedCorporatePackage} onChange={handleCorporatePackageChange}>
                                                                            <option value="">Select Corporate package</option>
                                                                            {corporate_events.map((corporate_event) => (
                                                                                <option key={corporate_event.id} value={corporate_event.id}>
                                                                                    {corporate_event.sub_package_name}
                                                                                </option>
                                                                            ))}

                                                                        </select>
                                                                        
                                                                        <span class="text-danger">{bookingErrorList.corporate_event_id}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-12'>
                                                                <div className='row'>
                                                    
      
      
    
         { selectedCorporatePackage && (corporate_packages.food_quantity > 0) && (
        <>  <div className="col-md-6">
        <div className="form-group">
          <label htmlFor="food_details" >Food Details</label>
          {corporate_packages.food_quantity && (
            <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
              *Select {corporate_packages.food_quantity} food options.
            </div>
          )}
          <div className="px-2 py-2 bg-white mt-1 ">
            {eventFoodOptions.map((food, index) => (
              <div
                className="d-flex align-items-center justify-content-between py-1"
                key={index}
               
              >
                <label style={{ marginTop: '5px' }}>{food}</label>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      width: '25px',
                      height: '25px',
                      padding: '0',
                      fontSize: '1.0em',
                       fontWeight: 'bold'
                    }}
                    onClick={() => handleEventFoodDecrement(food)}
                    disabled={selectedEventFoods[food] <= 0}
                  >
                    -
                  </button>
                
                  <span className="mx-2" >{selectedEventFoods[food] || 0}</span>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      width: '25px',
                      height: '25px',
                      padding: '0',
                      fontSize: '1.0em',
                      fontWeight: 'bold'
                    }}
                    onClick={() => handleEventFoodIncrement(food)}
                    disabled={getTotalSelectedEventFoods() >= corporate_packages.food_quantity}
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
            <span className="text-danger" >{bookingErrorList.selectedEventFoods}</span>
          </div>
        </div>
      </div>
    </>)}

  {selectedCorporatePackage && (corporate_packages.drink_quantity > 0) && (
     <div className="col-md-6">
     <div className="form-group">
       <label htmlFor="food_details" >Drink Details</label>
       {corporate_packages.drink_quantity && (
         <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
           *Select {corporate_packages.drink_quantity} drink options.
         </div>
       )}
       <div className="px-2 py-2 bg-white mt-1 ">
         {eventDrinkOptions.map((drink, index) => (
           <div
             className="d-flex align-items-center justify-content-between py-1"
             key={index}
            
           >
             <label style={{ marginTop: '5px' }}>{drink}</label>
             <div className="d-flex align-items-center">
               <button
                 type="button"
                 className="btn btn-outline-secondary"
                 style={{
                   width: '25px',
                   height: '25px',
                   padding: '0',
                   fontSize: '1.0em',
                    fontWeight: 'bold'
                 }}
                 onClick={() => handleEventDrinkDecrement(drink)}
                 disabled={selectedEventDrinks[drink] <= 0}
               >
                 -
               </button>
               <span className="mx-2" >{selectedEventDrinks[drink] || 0}</span>
               <button
                 type="button"
                 className="btn btn-outline-secondary"
                 style={{
                   width: '25px',
                   height: '25px',
                   padding: '0',
                   fontSize: '1.0em',
                   fontWeight: 'bold'
                 }}
                 onClick={() => handleEventDrinkIncrement(drink)}
                 disabled={getTotalSelectedEventDrinks() >= corporate_packages.drink_quantity}
               >
                 +
               </button>
             </div>
           </div>
         ))}
         <span className="text-danger" >{bookingErrorList.selectedEventDrinks}</span>
       </div>
     </div>
   </div>
)}
       
        </div> 
        </div></>


                                                            )}



                                                        </div>


                                                    </div>



            </div>
        </div>

        {/* Box 2 */}
        <div className="col-md-12">
            <div className="form-box py-4 px-3 bg-light border shadow-sm">
                {/* <h5 className="box-title mb-4">Contact Details</h5> */}
                <div className="row">
                <div className="col-md-6">
             
                                                        <div className="form-group">
                                                            <label htmlFor="firstname">First Name</label>
                                                            <input type="text" className="form-control" id="firstname" value={firstname} onChange={(e) => setFirstname(e.target.value)} placeholder="Enter First Name" />
                                                            <span class="text-danger">{bookingErrorList.firstname}</span>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="lastname">Last Name</label>
                                                            <input type="text" className="form-control" id="lastname" value={lastname} onChange={(e) => setLastname(e.target.value)} placeholder="Enter Last Name" />
                                                            <span class="text-danger">{bookingErrorList.lastname}</span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 form-group">
                                                        <label for="phone">Phone Number</label>
                                                        <input type="text" class="form-control" name="phone" id="phone" placeholder="Enter Phone Number" value={phone}
                                                            onChange={(event) => { setPhone(event.target.value); }} />
                                                        <span class="text-danger">{bookingErrorList.phone}</span>
                                                    </div>
                                                    <div class="col-md-6 form-group">
                                                        <label for="email">Email</label>
                                                        <input type="text" class="form-control" name="email" id="email" value={email} placeholder="Enter Email Address"
                                                            onChange={(event) => { setEmail(event.target.value); }} />

                                                        <span class="text-danger">{bookingErrorList.email}</span>
                                                  
                                                    </div>

                                                    {/* {selectedGameType && (
            <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
                *The total no of players must be between {minPlayers} and {maxPlayers}.
            </div>
        )} */}
          {selectedBirthdayPackage  && (
            <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
                *The total no of players must be between {birthday_packages.min_players} and {birthday_packages.max_players_in_a_slot }.
            </div>
        )}
          {selectedCorporatePackage  && (
            <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
                *The total no of players must be between {corporate_packages.min_players} and {corporate_packages.max_players_in_a_slot }.
            </div>
        )}


                                                    {/* <div className="col-md-4">
                                                        <div className="form-group py-2">
                                                            <label htmlFor="kids_count">Kids</label>
                                                            <input
                                                                type="number"
                                                                id="kids_count"
                                                                name="kids_count"
                                                                value={kids_count}
                                                                className="form-control"
                                                               // onChange={(e) => { setKids_count(e.target.value); }}
                                                                onChange={(e) => {
                                                                    if(!selectedPackageType)
                                                                    {
                                                                        alert('Please select Package Type.');
                                                                        setKids_count(0);
                                                                    }
                                                                else if (selectedPackageType == 'laser_tag_package'  && !selectedGameType) {
                                                                    alert('Please select a Game Type.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setKids_count(0);
                                                                } else if (selectedPackageType == 'birthday_package'  && !selectedBirthdayPackage){
                                                                    alert('Please select a birthday package.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setKids_count(0);
                                                                }
                                                                else if (selectedPackageType == 'corporate_event'  && !selectedCorporatePackage){
                                                                    alert('Please select a corporate package.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setKids_count(0);
                                                                }
                                                                else{
                                                                    setKids_count(e.target.value);
                                                                }
                                                            }}
                                                                min="0"
                                                                required
                                                            />
                                                        </div>
                                                    </div>    */}
                                                    <div className="col-md-4">
                                                        <div className="form-group py-2">
                                                            <label htmlFor="kids_count">Adults</label>
                                                            <input
                                                                type="number"
                                                                id="adults_count"
                                                                name="adults_count"
                                                                value={adults_count}
                                                                className="form-control"
                                                                // onChange={(e) => { setAdults_count(e.target.value); }}
                                                                onChange={(e) => {
                                                                    if(!selectedPackageType)
                                                                    {
                                                                        alert('Please select Package Type.');
                                                                        setAdults_count(0);
                                                                    }
                                                                else if (selectedPackageType == 'laser_tag_package'  && !selectedGameType) {
                                                                    alert('Please select a Game Type.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setAdults_count(0);
                                                                } else if (selectedPackageType == 'birthday_package'  && !selectedBirthdayPackage){
                                                                    alert('Please select a birthday package.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setAdults_count(0);
                                                                }
                                                                else if (selectedPackageType == 'corporate_event'  && !selectedCorporatePackage){
                                                                    alert('Please select a corporate package.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setAdults_count(0);
                                                                }
                                                                else{
                                                                    setAdults_count(e.target.value);
                                                                }
                                                            }}
                                                                required
                                                                min="0"
                                                            />
                                                        </div>
                                                    </div>


                                                 
                                                    <span class="text-danger">{totalPlayersErrorList}</span>
                                                    {/* <span class="text-danger">{bookingErrorList.total_players}</span> */}
                                                 
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="booking_time">Select Time:</label>
                                                            <div id="booking_time" className="form-control py-3">
                                                           
                                                                        
                                                                {timeSlotLoading ? (
                                                                    <div>Loading...</div>
                                                                ) : (


                                                                    bookingAvailableTimeSlots
                                                                    .map((timeSlot, index) => {
                                                                        const remainingSpace = availableSpaces[timeSlot] || 0;
                                                                         const game_type = game_types_array.find(item => item.id.toString() === selectedGameType);
                                                                           let holidayArray = holiday;

if (typeof holiday === 'string') {
  try {
    holidayArray = JSON.parse(holiday);
  } catch (e) {
    console.error('Failed to parse holiday JSON:', e);
    holidayArray = [];
  }
}

const parsedHolidays = Array.isArray(holidayArray)
  ? holidayArray.map(h => ({
      start: moment(h.holiday_from),
      end: h.holiday_to ? moment(h.holiday_to) : moment(h.holiday_from)
    }))
  : [];

const getSlotMomentRange = (timeSlot, selectedDate) => {
  const [startTime, endTime] = timeSlot.split(' - ');
  return {
    start: moment(`${selectedDate} ${startTime}`, 'YYYY-MM-DD hh:mm A'),
    end: moment(`${selectedDate} ${endTime}`, 'YYYY-MM-DD hh:mm A')
  };
};

const isSlotDuringHoliday = (timeSlot) => {
  const slot = getSlotMomentRange(timeSlot, selectedDate);
  return parsedHolidays.some(({ start, end }) => {
    const isOverlap =
      slot.start.isBetween(start, end, null, '[)') || // start inside holiday
      slot.end.isBetween(start, end, null, '(]') ||   // end inside holiday
      (slot.start.isSameOrBefore(start) && slot.end.isSameOrAfter(end)); // slot fully covers holiday
    if (isOverlap) {
     // console.log(`❗ Slot ${slot.start.format()} - ${slot.end.format()} overlaps with holiday ${start.format()} - ${end.format()}`);
    }
    return isOverlap;
  });
};


    const isSlotHoliday = isSlotDuringHoliday(timeSlot);                                                                    
                                                          
                                                                         let isDisabled = Array.isArray(disabledTimeSlots) && disabledTimeSlots.includes(timeSlot) || isSlotHoliday;
                                                                
                                                                       // Handle specific logic for "Private" game type
                                                                        if (game_type && game_type.game_type_name.toLowerCase().includes('private')) {
                                                                            // Disable slots that do not have exactly max players available
                                                                            if (remainingSpace !== game_type.max_players_in_a_slot) {
                                                                                isDisabled = true;
                                                                            }
                                                                        }
                                                                       

                                                                        //  // Handle specific logic for "Public" game type
                                                                        // if (game_type && game_type.game_type_name.toLowerCase().includes('public')) {
                                                                        //     // Disable slots that are already booked for "Private" game types
                                                                        //     const isBookedForPrivate = disabledTimeSlots.includes(timeSlot);
                                                                        //     if (isBookedForPrivate) {
                                                                        //         isDisabled = true;
                                                                        //     }
                                                                        // }

                                                                        // Handle specific logic for "Birthday Package"
                                                                        if (selectedPackageType === 'birthday_package' && game_packages.length > 0) {
                                                                            const maxPlayers = game_packages[0].max_players_in_a_slot; // Get max players allowed in a slot
                                                                        
                                                                            // Check if the current slot has enough availability for the package requirement
                                                                            const currentSlot = bookingAvailableTimeSlots[index]; // Current slot being processed
                                                                            const remainingSpace = availableSpaces[currentSlot] || 0;
                                                                        
                                                                            // Disable the slot if it doesn't have the required player availability
                                                                            if (remainingSpace !== maxPlayers) {
                                                                                isDisabled = true;
                                                                            }
                                                                            
                                                                        }

                                                                        if (selectedPackageType === 'corporate_event' && corporate_events.length > 0) {
                                                                            const maxPlayers = corporate_events[0].max_players_in_a_slot; // Get max players allowed in a slot
                                                                        
                                                                            // Check if the current slot has enough availability for the package requirement
                                                                            const currentSlot = bookingAvailableTimeSlots[index]; // Current slot being processed
                                                                            const remainingSpace = availableSpaces[currentSlot] || 0;
                                                                        
                                                                            // Disable the slot if it doesn't have the required player availability
                                                                            if (remainingSpace !== maxPlayers) {
                                                                                isDisabled = true;
                                                                            }
                                                                        }
                                                                        
                                                                       
                                                                        const currentTime = dayjs(); // Get current system time
                                                                        const slotStartTimeString = timeSlot.split(" - ")[0]; // Extract "04:30 PM" from "04:30 PM - 05:00 PM"
                                                                        const slotStartTime = dayjs(slotStartTimeString, "hh:mm A", true); // Parse correctly
                                                                        
                                                                        if (!slotStartTime.isValid()) {
                                                                          console.error("Invalid time format:", slotStartTimeString);
                                                                        }
                                                                        
                                                                        // Disable slots that have already passed for today
                                                                        if (dayjs(selectedDate).isSame(dayjs(), "day") && slotStartTime.isValid() && slotStartTime.isBefore(currentTime)) {
                                                                          isDisabled = true;
                                                                        }
                                                                    //  console.log(currentTime,timeSlot)
                                                                        return (
                                                                            <div
                                                                                key={index}
                                                                                className="form-group-checkbox d-flex align-items-center justify-content-between"
                                                                                style={isDisabled ? { color: '#a9a9a9', opacity: 0.6, pointerEvents: 'none' } : {}}
                                                                            >
                                                                                <div className="d-flex align-items-center">
                                                                                    <div>
                                                                                        <input
                                                                                            style={{ boxShadow: "2px 2px #059618", transition: "all .5s ease" }}
                                                                                            type="checkbox"
                                                                                            className="checkbox"
                                                                                            id={`timeslot_${index}`}
                                                                                            value={timeSlot}
                                                                                            checked={booking_time.includes(timeSlot)}
                                                                                            onChange={handleTimeSlotChange}
                                                                                            disabled={isDisabled}
                                                                                        />
                                                                                        <label
                                                                                            htmlFor={`timeslot_${index}`}
                                                                                            style={{ marginLeft: "5px" }}
                                                                                        >
                                                                                            <span style={isDisabled ? { textDecoration: 'line-through' } : {}}>
                                                                                                {timeSlot}
                                                                                            </span>
                                                                                            {/* <span style={{ color: 'green', marginLeft: '30px' }}>
                                                                                                {remainingSpace} left
                                                                                            </span> */}
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })
                                                                



                                                     
                                                                    
                                                                    // bookingAvailableTimeSlots.
                                                                    // filter((timeSlot, index, array)  => {
                                                                    //     const remainingSpace = availableSpaces[timeSlot] || 0;
                                                                    //     const game_type = game_types_array.find(item=> item.id.toString() === selectedGameType);
                                                                       
                                                                    //     // Only filter time slots if the selected game type is "Private"
                                                                    //     if (selectedPackageType === 'birthday_package') {
                                                                      
                                                                    //         const userGameCount = parseInt(game_count, 10); // Replace with the actual number of games selected by the user
                                                                    
                                                                    //         // Check for consecutive slots based on user count
                                                                    //         if (index + userGameCount <= array.length) {
                                                                    //             return array.slice(index, index + userGameCount).every(slot => availableSpaces[slot] === game_packages[0].max_players_in_a_slot);
                                                                    //         }
                                                                    //         // return remainingSpace === 30;
                                                                    //     }
                                                                    //     if (game_type) {
                                                                          
                                                                    //     if (game_type.game_type_name.toLowerCase().includes('private')) {
                                                                    //         // console.log(game_type)
                                                                    //         return remainingSpace === game_type.max_players_in_a_slot ; // Filter for slots with exactly 30 spaces left
                                                                    //     }
                                                                        
                                                                    // }
                                                                    //     return true;
                                                                    //      // Show all slots if not Private
                                                                    // }).
                                                                    // map((timeSlot, index) => {
                                                                    //     const isDisabled = Array.isArray(disabledTimeSlots) && disabledTimeSlots.includes(timeSlot);
                                                                    //     const remainingSpace = availableSpaces[timeSlot] || 0;
                                                                    //     return (
                                                                    //         <div
                                                                    //             key={index}
                                                                    //             className="form-group-checkbox d-flex align-items-center justify-content-between"
                                                                    //             style={isDisabled ? { color: '#a9a9a9', opacity: 0.6, pointerEvents: 'none' } : {}}
                                                                    //         >
                                                                    //             <div className="d-flex align-items-center">
                                                                    //                 <div>
                                                                    //                     <input
                                                                    //                         style={
                                                                    //                             { boxShadow: "2px 2px #059618", transition: "all .5s ease" }
                                                                    //                         }
                                                                    //                         type="checkbox"
                                                                    //                         className="checkbox"
                                                                    //                         id={`timeslot_${index}`}
                                                                    //                         value={timeSlot}
                                                                    //                         checked={booking_time.includes(timeSlot)}
                                                                    //                         onChange={handleTimeSlotChange}
                                                                    //                         disabled={isDisabled}
                                                                    //                     />
                                                                    //                     <label
                                                                    //                         htmlFor={`timeslot_${index}`}
                                                                    //                         style={{ marginLeft: "5px" }}
                                                                    //                     >
                                                                    //                         <span style={isDisabled ? { textDecoration: 'line-through' } : {}}>
                                                                    //                             {timeSlot}
                                                                    //                         </span>
                                                                    //                         <span style={{ color: 'green', marginLeft: '30px' }}>
                                                                    //                             {remainingSpace} left
                                                                    //                         </span>
                                                                    //                     </label>
                                                                    //                 </div>
                                                                    //             </div>
                                                                    //         </div>
                                                                    //     );
                                                                    // })
                                                                )}
                                                               
                                                            </div>
                                                            <span className="text-danger">{bookingErrorList.booked_time}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 pb-3">
    <div className="card shadow-sm p-3" >
        {/* Cart Header with Icon */}
        <div className="cart-header text-center pb-2">
        <h5 className="d-flex align-items-center justify-content-center fw-bold">
            <i className="bi bi-bag-fill text-success me-2" style={{ fontSize: "1.2rem", fontWeight:'bold' }}></i> 
            <span style={{ fontSize: "1.3rem" }}>CART</span>
        </h5>
    </div>

        {/* Time Slot Details */}
        <ul className="list-group list-group-flush" style={{lineHeight:'unset'}}>
        {Object.keys(cart_details).map((key, index) => {
        const slot = cart_details[key];

        return (
            <li key={index} className="list-group-item d-flex flex-column p-3">
                <div className="d-flex justify-content-between" style={{ fontSize: "0.85rem" }}>
                    {selectedPackageType === "laser_tag_package" ? (
                        <span>
                            {slot.time_slot} - {slot.total_players} X ${slot.price_for_slot}
                        </span>
                    ) : (
                      
                            slot.no_games > 1 ? (
                               
                               slot.price_for_slot == 0 ? (
                                <span>
                                    {slot.time_slot} - 1 X ${slot.row_total}
                                </span>
                            ) : (
                                <span>
                                {slot.time_slot} <br />
                                {slot.total_players} Players X {slot.no_games} Games X ${slot.price_for_slot}
                            </span>
                            )

                              
                            ) : (
                                <span>
                                    {slot.time_slot} <br />
                                    {slot.total_players} Players X ${slot.price_for_slot}
                                </span>
                            )
                        
                    )}
                    <strong >${slot.row_total}</strong>
                </div>
            </li>
        );
    })}

    {/* Display Extra Games and Players Separately */}
    {cart_details["extra_games"] &&
        cart_details["extra_games"].map((extraGame, index) => (
            <li key={`extra_game_${index}`} className="list-group-item d-flex flex-column p-3">
                <div className="d-flex justify-content-between" style={{ fontSize: "0.85rem" }}>
                    <span>
                        {extraGame.time_slot} <br />
                        {extraGame.total_players} Players X ${extraGame.price_for_slot}
                    </span>
                    <strong className="text-success">${extraGame.row_total}</strong>
                </div>
            </li>
        ))}

            {/* Base Package Price */}
            {basic_price > 0 && (
                <li className="list-group-item d-flex justify-content-between">
                  <span className="fw-bold text-success" style={{ fontSize: "1.0rem" }}>Base Package Price</span>
                    <strong className="fw-bold text-success"  style={{ fontSize: "1.0rem" }}>${basic_price.toFixed(2)}</strong>
                </li>
            )}

            {/* Extra Charges */}
            {extraPlayerPrice > 0 && (
                <li className="list-group-item d-flex justify-content-between">
                    <span className="fw-bold">Extra Player Price</span>
                    <strong className="fw-bold">${extraPlayerPrice.toFixed(2)}</strong>
                </li>
            )}
            {extraGamePrice > 0 && (
                <li className="list-group-item d-flex justify-content-between">
                    <span className="fw-bold">Extra Game Price</span>
                    <strong className="fw-bold">${extraGamePrice.toFixed(2)}</strong>
                </li>
            )}

            {/* Subtotal */}
            <li className="list-group-item d-flex justify-content-between border-top">
    <span className="text-success fw-bold">SUB TOTAL</span>
    <strong className="text-success fw-bold">
    ${(
        selectedCorporatePackage && corporatePrice?.price
            ? Number(corporatePrice.price)
            : selectedBirthdayPackage && birthdayPrice?.price
            ? Number(birthdayPrice.price)
            : timeSlotDetails?.price
            ? Number(timeSlotDetails.price)
            : 0  // Default fallback to prevent NaN
    ).toFixed(2)}
</strong>

</li>



  {discountDetails.map((discount, index) => {
    const subtotal = (
      selectedCorporatePackage && corporatePrice?.price
        ? Number(corporatePrice.price)
        : selectedBirthdayPackage && birthdayPrice?.price
        ? Number(birthdayPrice.price)
        : timeSlotDetails?.price
        ? Number(timeSlotDetails.price)
        : 0
    );

    const discountAmount =
      discount.type === 'percentage'
        ? ((subtotal * discount.value) / 100).toFixed(2)
        : Number(discount.value).toFixed(2);

        const label =
        discount.type === 'percentage'
          ? `${discount.description || 'Discount'} (${discount.value}%)`
          : discount.description || 'Discount';
      
    return (
        <li key={index} className="list-group-item d-flex justify-content-between" style={{ minWidth: '120px' }}>
        <span className="fw-bold">{label}</span>
        <span className="fw-bold">- ${discountAmount} <i
      className="bi bi-trash3 ms-2 text-danger"
      style={{ fontSize: '0.75rem', cursor: 'pointer' }}
      onClick={() => handleRemoveDiscount(index)}
      title="Remove discount"
    ></i></span>
       
      </li>
    );
  })}




 {promoDetails.map((promo, index) => {

     const subtotal = (
      selectedCorporatePackage && corporatePrice?.price
        ? Number(corporatePrice.price)
        : selectedBirthdayPackage && birthdayPrice?.price
        ? Number(birthdayPrice.price)
        : timeSlotDetails?.price
        ? Number(timeSlotDetails.price)
        : 0
    );
  // Determine the label based on promo type
  const label = promo.type === "percentage"
    ? `${promo.code_name} (${promo.value}%)`
    : promo.code_name;

  // Calculate amount off (already done when adding promo, or use subtotal * % here if needed)
  const amountOff = promo.type === "percentage"
    ? (subtotal * promo.value / 100).toFixed(2)
    : Number(promo.value).toFixed(2);

  return (
    <li key={index} className="list-group-item d-flex justify-content-between" style={{ minWidth: '120px' }}>
      <span className="fw-bold">{label}</span>
      <span className="fw-bold">
        - ${amountOff}
        <i
          className="bi bi-trash3 ms-2 text-danger"
          style={{ fontSize: '0.75rem', cursor: 'pointer' }}
          onClick={() => handleRemovePromo(index)}
          title="Remove promo code"
        ></i>
      </span>
    </li>
  );
})}





{/* {discountDetails.map((discount, index) => (
  <li key={index} className="list-group-item d-flex justify-content-between" style={{ minWidth: '120px' }}>
    <span className="fw-bold">{discount.description || 'Discount'}</span>
    <span className="fw-bold">
      {discount.type === 'percentage'
        ? `- ${discount.value}%`
        : `- $${discount.value}`}
            <i
      className="bi bi-trash3 ms-2 text-danger"
      style={{ fontSize: '0.75rem', cursor: 'pointer' }}
      onClick={() => handleRemoveDiscount(index)}
      title="Remove discount"
    ></i>
    </span>
  
  </li>
))} */}

<li className="list-group-item d-flex justify-content-between">
                <span className="fw-bold">TOTAL (before HST)</span>
               <strong className="fw-bold">${totalBeforeHst.toFixed(2)}</strong>
            </li>

            {/* HST */}
            <li className="list-group-item d-flex justify-content-between">
                <span className="fw-bold">HST</span>
                <strong className="fw-bold">${hst.toFixed(2)}</strong>
            </li>

            {/* Grand Total */}
            <li className="list-group-item d-flex justify-content-between fw-bold">
                <span>GRAND TOTAL</span>
                <strong>${grand_total.toFixed(2)}</strong>
            </li>

            {/* Deposit Amount */}
            <li className="list-group-item d-flex flex-column">
            <span className="fw-bold">Deposit</span>
            <span className="text-muted">{depositInfo}</span>
            </li>

            {/* Deposit Input Field */}
            <li>
                <input
                    type="text"
                    className="form-control text-center "
                    value={Number(deposit_amount).toFixed(2)}
                    readOnly
                />
            </li>


{/* Discount Row */}
<li className="list-group-item d-flex justify-content-between mt-2">
<button className="btn btn-sm btn-primary" onClick={handleAddDiscount}><i className={`bi bi-plus-circle `}></i> Discount</button>
<button className="btn btn-primary btn-sm" onClick={handleApplyPromo}>
<i className={`bi bi-plus-circle `}></i> Promo Code
    </button>
</li>



        </ul>

        {/* Error Message */}
        {bookingErrorList.deposit_amount && (
            <span className="text-danger">{bookingErrorList.deposit_amount}</span>
        )}
    </div>
</div>






                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="amount_paid">Amount Paid</label>
                                                            <input type="number" className="form-control" id="amount_paid" value={amount_paid}   onChange={(e) => handleAmountPaidChange(e.target.value)}  min='0' />
                                                            <span class="text-danger">{bookingErrorList.amount_paid}</span>
                                                        </div>
                                                     
                                                    </div>
                                                

                                                    <div className="col-md-6">
                                                    <div className="form-group">
                                <label htmlFor="payment_method">Payment Method</label>
                                <select  class="form-select" id="payment_method" name="payment_method" value={payment_method} 
                                 onChange={handlePaymentMethodChange }>
         <option value="">Select Payment Method</option>
              <option value="Cash">Cash</option>
              <option value="Credit">Credit </option>
              <option value="Debit">Debit </option>
              <option value="E-transfer">E-transfer</option>
         
        </select>
                                {/* <span className="text-danger">{bookingErrorList.payment_method}</span> */}
                            </div>
                                                    </div>


                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="note">Note</label>
                                                            <input type="text" className="form-control" id="note" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Enter Note" />
                                                            <span class="text-danger">{bookingErrorList.note}</span>
                                                        </div>
                                                    </div>
</div>


               
            </div>
        </div>
    </div>
</div>





                                            <div className="content px-3">
                                               
                                                   

                                    




                                                    <div class="d-flex justify-content-end ms-auto py-3">


                                                        <button onClick={bookGame} class="btn btn-sm btn_secondary text-white "><i class="bi bi-send"></i>  {loading ? "Booking..." : "Book"} </button>
                                                    </div>   
                                            </div>

                                        </div>
                                    </div>
                                )
                            )}



{view === 'details' && (
    <div className='col-md-4'>
        <div className="py-3 mt-4 border-top bg-light rounded shadow-sm">
            <h3 className="vm_font_semi_bold border-bottom mb-3 px-3 pb-2 ">
                Booking Details
            </h3>
<div className="content py-0 bg-white px-3 py-3 shadow-lg mb-3 w-100" >
            <div className="text-center">
                <h2 className="vm_font_bold mt-2">{bookingDetails.firstname} {bookingDetails.lastname}</h2>
                <div className="d-flex justify-content-center mb-3">
                    <a style={{ cursor: "pointer" }} className="d-flex align-items-center pe-3 text-decoration-none text-dark">
                        <i className="bi bi-telephone-fill me-2 text-success"></i>
                        <p className="mb-0">{bookingDetails.phone}</p>
                    </a>

                    <a style={{ cursor: "pointer" }} className="d-flex align-items-center text-decoration-none text-dark">
                        <i className="bi bi-envelope-fill me-2 text-success"></i>
                        <p className="mb-0">{bookingDetails.email}</p>
                    </a>
                </div>
            </div>

            <div className="row border-top pb-3">
                {[
                    { label: 'Game Name', value: bookingDetails.game_name },
                    { label: 'Location', value: bookingDetails.location_name },
                    { label: 'Game Package', value:  bookingDetails.game_type_name ||
                        (bookingDetails.package_name === 'Corporate' 
                          ? `${bookingDetails.package_name} - ${bookingDetails.corporate_package_name}`
                          : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`
                        )},
                        // value: bookingDetails.game_type_name ? bookingDetails.game_type_name : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}` },
                    { label: 'Booked Date', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-calendar3 me-2 text-success" ></i>
                            <span>{moment(bookingDetails.booked_date).format('D MMMM YYYY')}</span>
                        </div>
                    ) },
                    { label: 'Booked Time', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-clock-fill me-2 text-success" ></i>
                            <span>{bookingDetails.booked_times}</span>
                        </div>
                    ) },
                    { label: 'Adult Count', value: bookingDetails.no_of_adults },
                    { label: 'Kids Count', value: bookingDetails.no_of_children },
                    { label: 'Amount paid', value: bookingDetails.amount_paid },
                    
                    ...(bookingDetails.package_name 
                        ? [
                          
                            { label: 'Birthday Kid Name', value: bookingDetails.birthday_kid_name },
                            ...(bookingDetails.food_details
                                ? [{
                                    label: 'Food details',
                                    value: Object.entries(JSON.parse(bookingDetails.food_details || "{}"))
                                      .map(([name, count]) => `${name} (${count})`)  // Format as "Cheese (1)"
                                      .join(", ")  // Join with ", " for proper display
                                }]
                                : []),
                            
                            ...(bookingDetails.drink_details
                                ? [{
                                    label: 'Drink details',
                                    value: Object.entries(JSON.parse(bookingDetails.drink_details || "{}"))
                                      .map(([name, count]) => `${name} (${count})`)  // Format as "Cheese (1)"
                                      .join(", ")  // Join with ", " for proper display
                                }]
                                : []),
                           

                        ]
                        : [])

                    
                    
                    // { label: 'Birthday Kid Name', value: bookingDetails.birthday_kid_name },
                    // { label: 'Food details', value: bookingDetails.food_details },
                    // { label: 'Drink details', value: bookingDetails.drink_details },

                ].map((detail, index) => (
                    <div className="d-flex border-bottom py-2" key={index}>
                        <div className="col-5 p-1 border-end vm_font_bold text-secondary">{detail.label}</div>
                        <div className="col-7 p-1 ps-3">{detail.value}</div>
                    </div>
                ))}
          
   <div class="d-flex justify-content-center pt-3 ">
<button class="btn btn-sm btn_secondary"  onClick={() => handleViewBookings(bookingDetails.booking_id)}  >
View More Details</button>
</div>

            </div>
        </div>
    </div>
    </div>
)}

 </div>


                    </div>
                </div>
            </div>

            <Modal show={showDiscountModal} onHide={handleCloseDiscountModal}>
  <Modal.Header closeButton>
    <Modal.Title>Apply Discount</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="mb-3">
    <div className="form-group">
      <label htmlFor="discountType">Discount Type</label>
      <select
        className="form-control"
        value={discountType}
        onChange={e => setDiscountType(e.target.value)}
      >
        <option value="">Select Type</option>
        <option value="percentage">Percentage</option>
        <option value="amount">Fixed Amount</option>
      </select>
    </div>
    </div>

    <div className="mb-3">
    <div className="form-group">
    <label htmlFor="discountValue">Discount Value</label>
      <input
        type="number"
        className="form-control"
        value={discountValue}
        onChange={e => setDiscountValue(e.target.value)}
     
      />
    </div>
    </div>

    <div className="mb-3">
    <div className="form-group">
    <label htmlFor="description">Description</label>
      <textarea
        className="form-control"
        rows={3}
        value={discountDescription}
        onChange={e => setDiscountDescription(e.target.value)}
       
      />
    </div>
    </div>
  </Modal.Body>

  <Modal.Footer>
 
  <button class="btn btn-sm btn_secondary" onClick={applyDiscount}>
      Apply
    </button>
  </Modal.Footer>
</Modal>


<Modal show={showPromoModal} onHide={handleClosePromoModal}>
  <Modal.Header closeButton>
    <Modal.Title>Apply Promo Code</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="mb-3">
    <div className="form-group">
      <label htmlFor="promoCode">Promo Code</label>
      <select
        className="form-control"
        value={promoCode}
        onChange={e => setPromoCode(e.target.value)}
      >
   <option value="">Select Promo Code</option>
{promoCodeList
   .filter(code =>
      code.applicable_locations
        ?.split(',')
        .map(loc => loc.trim())
      .includes(String(selectedGameLocation))
    )
  .filter(code =>
    code.applicable_game_packages
      ?.split(',')
      .map(pkg => pkg.trim())
      .includes(selectedPackageType)
  )
   .filter(code => {
   //   const today = new Date().toLocaleDateString("en-CA", {timeZone: 'America/Toronto'});

    //   const activeFrom = code.active_from ?  new Date(code.active_from).toLocaleDateString('en-CA') : null;
    //   const activeTo = code.active_to ?  new Date(code.active_to).toLocaleDateString('en-CA') : null;

    const activeFrom = code.active_from ? code.active_from : null;
    const activeTo = code.active_to ?  code.active_to : null;

  
      // Always active if both dates are missing
      if (!activeFrom && !activeTo) return true;

      if (activeFrom && !activeTo) return today >= activeFrom;
 
      if (!activeFrom && activeTo) return today <= activeTo;

      return today >= activeFrom && today <= activeTo;
    })
    .filter(code => {
    const selectedCount = promoDetails.filter(p => p.code_name === code.code_name).length;
      if (!code.usable_count || code.usable_count === 0) return true;
    return code.usable_count > (code.used_count + selectedCount);
  })
  .map(code => (
    <option key={code.id} value={code.code_name}>
      {code.code_name}
    </option>
))}
      </select>
    </div>
    </div>

   

  </Modal.Body>

  <Modal.Footer>
 
  <button class="btn btn-sm btn_secondary" onClick={applyPromoCode}>
      Apply
    </button>
  </Modal.Footer>
</Modal>



        </div>



    );
}

export default ViewBooking;
